export const LOCAL_STORAGE_KEY = "user@bill";

export const borderBarriers = {
  andhraPradesh: [
    { name: "KODIKONDA" },
    { name: "GARIKAPADU" },
    { name: "ICHHAPURAM" },
    { name: "PALAMANER" },
  ],
  arunachalPradesh: [
    { name: 'PAPUM PARE' },       // Banderdewa / Kimin / Gohpur
    { name: 'WEST KAMENG' },      // Bhalukpong
    { name: 'WEST SIANG' },       // Likabali
    { name: 'EAST SIANG' },       // Ruksin / Kemi
    { name: 'LOWER DIBANG VALLEY' }, // Shantipur
    { name: 'LOHIT' },            // Sunpura / Dirak Gate
    { name: 'CHANGLANG' },        // Namdang / Jairampur / Kharsang / Bordumsa
    { name: 'TIRAP' }, 
  ],
  assam: [
    { name: "KAMRUP" },
    { name: "NAGAON" },  
    { name: "JORHAT" },
    { name: "SIVASAGAR" },
    { name: "GOLAGHAT" },
    { name: "DIBRUGARH" },
    { name: "LAKHIMPUR" },
    { name: "DIMA HASAO" },
    { name: "KARBI ANGLONG" },
    { name: "KARIMGANJ" },
    { name: "CACHAR" },
    { name: "SONITPUR" },
    { name: "DARRANG" },
    { name: "NALBARI" },
    { name: "KOKRAJHAR" },
    { name: "DHUBRI" },
    { name: "GOALPARA" },
    { name: "BONGAIGAON" },
    { name: "MORIGAON" },
    { name: "DHEMAJI" },
    { name: "TINSUKIA" },
    { name: "HAILAKANDI" },
    { name: "KAMRUP(M)" },
    { name: "UDALGURI" },
    { name: "CHIRANG" },
    { name: "MAJULI" },
    { name: "KARBI ANGLONG(WEST)" },
    { name: "HOJAI" },
    { name: "BISWANATH" },
    { name: "SALMARA(SOUTH)" },
    { name: "STA ASSAM" },
    { name: "CHARAIDEO" },
  ],
  bihar: [
    { name: "RAXAUL" },
    { name: "JOGBANI" },
    { name: "DOBHI" },
    { name: "KARMANASA" },
    { name: "SASARAM" },
  ],
  chhattisgarh: [
    { name: "SARAIPALI" },
    { name: "BAGHNADI" },
    { name: "DONGARGARH" },
    { name: "BACHELI" },
  ],
  damanDiu: [
    { name: "Daman District" },
    { name: "Diu District" },
  ],
  goa: [
    { name: "PATRADEVI" },
    { name: "MOLLEM" },
    { name: "POLLEM" },
    { name: "DODAMARG" },
  ],
  gujrat: [
    { name: "SHAMLAJI" },
    { name: "RATANPUR" },
    { name: "SAMKHIYALI" },
    { name: "SONGADH" },
  ],
  haryana: [
    { name: "KUNDLI" },
    { name: "SHAMBHU" },
    { name: "DABWALI" },
    { name: "GURUGRAM" },
  ],
  himachalPradesh: [
    { name: "PARWANOO" },
    { name: "SWARGHAT" },
    { name: "BADDI" },
    { name: "MEHATPUR" },
    { name: "PAONTA SAHIB" },
  ],
  jharkhand: [
    { name: "CHIRKUNDA" },
    { name: "BARHI" },
    { name: "BAHARAGORA" },
    { name: "MANOHARPUR" },
  ],
  karnataka: [
    { name: "ATTIBELE" },
    { name: "KOGNOLI" },
    { name: "TALAPADY" },
    { name: "HUMNABAD" },
    { name: "GUNDLUPET" },
  ],
  kerala: [
    { name: "WALAYAR" },
    { name: "MUTHANGA" },
    { name: "MANJESHWAR" },
    { name: "ARYANKAVU" },
    { name: "KUMILY" },
  ],
  madhyaPradesh: [
    { name: "SENDHWA" },
    { name: "BETUL" },
    { name: "MORENA" },
    { name: "REWA" },
  ],
  mp: [
    { name: "SENDHWA" },
    { name: "BETUL" },
    { name: "MORENA" },
    { name: "REWA" },
  ],
  maharashtra: [
    { name: "TALASARI" },
    { name: "NAVAPUR" },
    { name: "KOGNOLI" },
    { name: "BHIWANDI" },
    { name: "SINNAR" },
  ],
  manipur: [
    { name: "MOREH" },
    { name: "MAO GATE" },
    { name: "JIRIBAM" },
    { name: "JESSAMI" },
  ],
  meghalaya: [
    { name: "JORABAT" },
    { name: "DAWKI" },
    { name: "BORSORA" },
    { name: "RATACHERRA" },
  ],
  mizoram: [
    { name: "VAIRENGTE" },
    { name: "KANHMUN" },
    { name: "ZOKHAWTHAR" },
    { name: "KAWRPUICHHUAH" },
  ],
  nagaland: [
    { name: "DIMAPUR" },
    { name: "KHUZAMA" },
    { name: "MOKOKCHUNG" },
    { name: "TIZIT" },
  ],
  odisha: [
    { name: "JALESWAR" },
    { name: "BIRAMITRAPUR" },
    { name: "SOHELA" },
    { name: "SUNKI" },
    { name: "LUHURACHATI" },
  ],
  puducherry: [
    { name: "Puducherry" },
    { name: "Karaikal" },
    { name: "Mahe" },
    { name: "Yanam" },
  ],
  punjab: [
    { name: "ATTARI" },
    { name: "SHAMBHU" },
    { name: "MADHOPUR" },
    { name: "DABWALI" },
  ],
  rajasthan: [
    { name: "ALWAR" },
    { name: "BHARATPUR" },
    { name: "DHOLPUR" },
    { name: "DUNGARPUR" },
    { name: "HANUMANGARH" },
    { name: "JHALAWAR" },
  ],
  sikkim: [
    { name: "GANGTOK" },
    { name: "NAMCHI" },
  ],
  tamilNadu: [
    { name: "HOSUR" },
    { name: "WALAYAR" },
    { name: "KODIKONDA" },
    { name: "KALIYAKKAVILAI" },
    { name: "GUDALUR" },
  ],
  telangana: [
    { name: "Adilabad" },
    { name: "Kumuram Bheem (Asifabad)" },
    { name: "Nirmal" },
    { name: "Nizamabad" },
    { name: "Kamareddy" },
    { name: "Sangareddy" },
    { name: "Vikarabad" },
    { name: "Mahabubnagar" },
    { name: "Jogulamba Gadwal" },
    { name: "Wanaparthy" },
    { name: "Nagarkurnool" },
    { name: "Nalgonda" },
    { name: "Suryapet" },
    { name: "Khammam" },
    { name: "Bhadradri Kothagudem" },
  ],
   tripura: [
    { name: "West Tripura" },
    { name: "Sepahijala" },
    { name: "Gomati" },
    { name: "South Tripura" },
    { name: "North Tripura" },
    { name: "Unakoti" },
    { name: "Dhalai" },
  ],
  up: [
    { name: "GHAZIABAD" },
    { name: "NOIDA" },
    { name: "ALIGARH" },
    { name: "SONAULI" },
  ],
  uk: [
    { name: "ASHARORI" },
    { name: "RAMPUR TIRAHA" },
    { name: "KICHHA" },
    { name: "BANBASA" },
  ],
  westBengal: [
    { name: "PETRAPOLE" },
    { name: "PHULBARI" },
    { name: "HALDIBARI" },
    { name: "DALKHOLA" },
  ],
};

export const checkposts = {
  andhraPradesh: [
    { name: "KODIKONDA CHECKPOST" },
    { name: "GARIKAPADU CHECKPOST" },
    { name: "ICHHAPURAM TOLL" },
    { name: "PALAMANER CHECKPOST" },
  ],
  arunachalPradesh: [
    { name: "BANDERDEWA GATE" },
    { name: 'KIMIN' },
    { name: 'GOHPUR' },
    { name: 'BHALUKPONG' },
    { name: 'LIKABALI' },
    { name: 'RUKSIN' },
    { name: 'KEMI' },
    { name: 'SHANTIPUR' },
    { name: 'SUNPURA' },
    { name: 'DIRAK GATE' },
    { name: 'NAMDANG' },
    { name: 'JAIRAMPUR' },
    { name: 'KHARSANG' },
    { name: 'BORDUMSA' },
    { name: 'DEOMALI' },
    { name: 'HUKANJURI' },
    { name: 'KANUBARI' },
],
 
   assam: [
    { name: "KAMRUP", borderBarrier: "KAMRUP" },
    { name: "NAGAON", borderBarrier: "NAGAON" },
    { name: "JORHAT", borderBarrier: "JORHAT" },
    { name: "SIVASAGAR", borderBarrier: "SIVASAGAR" },
    { name: "GOLAGHAT", borderBarrier: "GOLAGHAT" },
    { name: "DIBRUGARH", borderBarrier: "DIBRUGARH" },
    { name: "LAKHIMPUR", borderBarrier: "LAKHIMPUR" },
    { name: "DIMA HASAO", borderBarrier: "DIMA HASAO" },
    { name: "KARBI ANGLONG", borderBarrier: "KARBI ANGLONG" },
    { name: "KARIMGANJ", borderBarrier: "KARIMGANJ" },
    { name: "CACHAR", borderBarrier: "CACHAR" },
    { name: "SONITPUR", borderBarrier: "SONITPUR" },
    { name: "DARRANG", borderBarrier: "DARRANG" },
    { name: "NALBARI", borderBarrier: "NALBARI" },
    { name: "KOKRAJHAR", borderBarrier: "KOKRAJHAR" },
    { name: "DHUBRI", borderBarrier: "DHUBRI" },
    { name: "GOALPARA", borderBarrier: "GOALPARA" },
    { name: "BONGAIGAON", borderBarrier: "BONGAIGAON" },
    { name: "MORIGAON", borderBarrier: "MORIGAON" },
    { name: "DHEMAJI", borderBarrier: "DHEMAJI" },
    { name: "TINSUKIA", borderBarrier: "TINSUKIA" },
    { name: "HAILAKANDI", borderBarrier: "HAILAKANDI" },
    { name: "KAMRUP(M)", borderBarrier: "KAMRUP(M)" },
    { name: "UDALGURI", borderBarrier: "UDALGURI" },
    { name: "CHIRANG", borderBarrier: "CHIRANG" },
    { name: "MAJULI", borderBarrier: "MAJULI" },
    { name: "KARBI ANGLONG(WEST)", borderBarrier: "KARBI ANGLONG(WEST)" },
    { name: "HOJAI", borderBarrier: "HOJAI" },
    { name: "BISWANATH", borderBarrier: "BISWANATH" },
    { name: "SALMARA(SOUTH)", borderBarrier: "SALMARA(SOUTH)" },
    { name: "STA ASSAM", borderBarrier: "STA ASSAM" },
    { name: "CHARAIDEO", borderBarrier: "CHARAIDEO" },
  ],

  bihar: [
    { name: "RAXAUL ICP" },
    { name: "JOGBANI CHECKPOST" },
    { name: "DOBHI BARRIER" },
    { name: "KARMANASA BRIDGE" },
    { name: "SASARAM TOLL" },
  ],
  chhattisgarh: [
    { name: "SARAIPALI CHECKPOST" },
    { name: "BAGHNADI CHECKPOST" },
    { name: "DONGARGARH CHECKPOST" },
    { name: "BACHELI BARRIER" },
  ],
  damanDiu: [
    { name: "Vapi–Daman Checkpost", borderBarrier: "Daman District" },
    { name: "Somnath Junction Checkpost", borderBarrier: "Daman District" },

    { name: "Ghoghla Checkpost", borderBarrier: "Diu District" },
    { name: "Simbor Checkpost", borderBarrier: "Diu District" },
  ],
  goa: [
    { name: "PATRADEVI CHECKPOST" },
    { name: "MOLLEM CHECKPOST" },
    { name: "POLLEM GATE" },
    { name: "DODAMARG CHECKPOST" },
  ],
  gujrat: [
    { name: "SHAMLAJI CHECKPOST" },
    { name: "RATANPUR BORDER POST" },
    { name: "SAMKHIYALI CHECKPOST" },
    { name: "SONGADH BARRIER" },
  ],
  haryana: [
    { name: "KUNDLI BORDER" },
    { name: "SHAMBHU BARRIER" },
    { name: "DABWALI CHECKPOST" },
    { name: "KHERKI DAULA TOLL" },
  ],
  himachalPradesh: [
    { name: "PARWANOO BARRIER" },
    { name: "SWARGHAT CHECKPOST" },
    { name: "BADDI CHECKPOST" },
    { name: "MEHATPUR BARRIER" },
    { name: "PAONTA SAHIB GATE" },
  ],
  jharkhand: [
    { name: "CHIRKUNDA INTEGRATED CHECKPOST" },
    { name: "BARHI TOLL CHECKPOST" },
    { name: "BAHARAGORA CHECKPOST" },
    { name: "MANOHARPUR BARRIER" },
  ],
  karnataka: [
    { name: "ATTIBELE CHECKPOST" },
    { name: "KOGNOLI CHECKPOST" },
    { name: "TALAPADY BORDER" },
    { name: "HUMNABAD CHECKPOST" },
    { name: "GUNDLUPET CHECKPOST" },
  ],
  kerala: [
    { name: "WALAYAR CHECKPOST" },
    { name: "MUTHANGA CHECKPOST" },
    { name: "MANJESHWAR CHECKPOST" },
    { name: "ARYANKAVU CHECKPOST" },
    { name: "KUMILY CHECKPOST" },
  ],
  madhyaPradesh: [
    { name: "SENDHWA CHECKPOST" },
    { name: "BETUL INTEGRATED CHECKPOST" },
    { name: "CHAMBAL MORENA BARRIER" },
    { name: "REWA HANUMANA CHECKPOST" },
  ],
  mp: [
    { name: "SENDHWA CHECKPOST" },
    { name: "BETUL INTEGRATED CHECKPOST" },
    { name: "CHAMBAL MORENA BARRIER" },
    { name: "REWA HANUMANA CHECKPOST" },
  ],
  maharashtra: [
    { name: "TALASARI CHECKPOST" },
    { name: "NAVAPUR CHECKPOST" },
    { name: "KOGNOLI BORDER" },
    { name: "BHIWANDI OCTROI" },
    { name: "SINNAR TOLL" },
  ],
  manipur: [
    { name: "MOREH ICP" },
    { name: "MAO GATE CHECKPOST" },
    { name: "JIRIBAM CHECKPOST" },
    { name: "JESSAMI CHECKPOST" },
  ],
  meghalaya: [
    { name: "JORABAT CHECKPOST" },
    { name: "DAWKI ICP" },
    { name: "BORSORA CHECKPOST" },
    { name: "RATACHERRA CHECKPOST" },
  ],
  mizoram: [
    { name: "VAIRENGTE CHECKGATE" },
    { name: "KANHMUN CHECKGATE" },
    { name: "ZOKHAWTHAR CHECKPOST" },
    { name: "KAWRPUICHHUAH CHECKPOST" },
  ],
  nagaland: [
    { name: "NEW FIELD DIMAPUR GATE" },
    { name: "KHUZAMA CHECKPOST" },
    { name: "MOKOKCHUNG CHECKPOST" },
    { name: "TIZIT GATE" },
  ],
  odisha: [
    { name: "JALESWAR CHECKPOST" },
    { name: "BIRAMITRAPUR CHECKPOST" },
    { name: "SOHELA CHECKPOST" },
    { name: "SUNKI CHECKGATE" },
    { name: "LUHURACHATI BARRIER" },
  ],
  puducherry: [
   { name: 'GORIMEDU', borderBarrier: 'Puducherry' },
    { name: 'KALAPET', borderBarrier: 'Puducherry' },
    { name: 'KANNIYAKOIL', borderBarrier: 'Puducherry' },
    { name: 'MADAGAIPET', borderBarrier: 'Puducherry' },
    { name: 'THIRUKANNUR', borderBarrier: 'Puducherry' },

    // Karaikal
    { name: 'AMBAGARATHUR', borderBarrier: 'Karaikal' },
    { name: 'NANDALAR', borderBarrier: 'Karaikal' },
    { name: 'VANJURE', borderBarrier: 'Karaikal' },

    // Mahe
    { name: 'MAHE', borderBarrier: 'Mahe' },

    // Yanam
    { name: 'YANAM', borderBarrier: 'Yanam' },
  ],
  punjab: [
    { name: "ATTARI ICP" },
    { name: "SHAMBHU BARRIER" },
    { name: "MADHOPUR CHECKPOST" },
    { name: "DABWALI CHECKPOST" },
  ],
  rajasthan: [
    { name: "SHAHJAHANPUR" },
    { name: "BHIWADI MOD" },
    { name: "CHAMBAL DHOLPUR" },
    { name: "RATANPUR DUNGARPUR" },
    { name: "SANGARIA" },
    { name: "TEENDHAR JHALAWAR" },
  ],
  sikkim: [
    // For District: GANGTOK
    { name: "RANGPO, EAST SIKKIM", district: "GANGTOK" },

    // For District: NAMCHI
    { name: "KELLI, SOUTH SIKKIM", district: "NAMCHI" },
  ],

  tamilNadu: [
    { name: "HOSUR CHECKPOST" },
    { name: "WALAYAR CHECKPOST" },
    { name: "KODIKONDA CHECKPOST" },
    { name: "KALIYAKKAVILAI CHECKPOST" },
    { name: "GUDALUR NADUGANI CHECKPOST" },
  ],
  telangana: [
    { name: "Bela Checkpost", borderBarrier: "Adilabad" },
    { name: "Mancherial Checkpost", borderBarrier: "Adilabad" },

    { name: "Sirpur Checkpost", borderBarrier: "Kumuram Bheem (Asifabad)" },

    { name: "Soan Checkpost", borderBarrier: "Nirmal" },

    { name: "Basar Checkpost", borderBarrier: "Nizamabad" },
    { name: "Madnoor Border Checkpost", borderBarrier: "Nizamabad" },

    { name: "Jukkal Checkpost", borderBarrier: "Kamareddy" },

    { name: "Zaheerabad Checkpost", borderBarrier: "Sangareddy" },
    { name: "Narayankhed Checkpost", borderBarrier: "Sangareddy" },

    { name: "Tandur Checkpost", borderBarrier: "Vikarabad" },

    { name: "Jadcherla Checkpost", borderBarrier: "Mahabubnagar" },
    { name: "Narayanpet–KA Border Checkpost", borderBarrier: "Mahabubnagar" },

    { name: "Gadwal–Kurnool Checkpost", borderBarrier: "Jogulamba Gadwal" },

    { name: "Pebbair Checkpost", borderBarrier: "Wanaparthy" },

    { name: "Kalwakurthy–Srisailam Route Checkpost", borderBarrier: "Nagarkurnool" },

    { name: "Kodad Checkpost", borderBarrier: "Nalgonda" },

    { name: "Khammam Border Checkpost", borderBarrier: "Suryapet" },

    { name: "Wyra Checkpost", borderBarrier: "Khammam" },
    { name: "Madhira–AP Border Checkpost", borderBarrier: "Khammam" },

    { name: "Bhadrachalam Checkpost", borderBarrier: "Bhadradri Kothagudem" },
  ],
  tripura: [
    { name: "Akhaura Checkpost", borderBarrier: "West Tripura" }, // international
    { name: "Agartala Checkpost", borderBarrier: "West Tripura" },

    { name: "Bishalgarh Checkpost", borderBarrier: "Sepahijala" },

    { name: "Rani Bazar Checkpost", borderBarrier: "Gomati" },
    { name: "Muhuripur Checkpost", borderBarrier: "Gomati" },

    { name: "Belonia Checkpost", borderBarrier: "South Tripura" }, // India–Bangladesh
    { name: "Sabroom Checkpost", borderBarrier: "South Tripura" },

    { name: "Churaibari Checkpost", borderBarrier: "North Tripura" },

    { name: "Kumarghat Checkpost", borderBarrier: "Unakoti" },

    { name: "Ambassa Checkpost", borderBarrier: "Dhalai" },
  ],

  up: [
    { name: "GHAZIABAD DELHI BORDER" },
    { name: "NOIDA DND CHECKPOST" },
    { name: "ALIGARH TAPPAL BARRIER" },
    { name: "SONAULI ICP" },
  ],
  uk: [
    { name: "ASHARORI CHECKPOST" },
    { name: "RAMPUR TIRAHA CHECKPOST" },
    { name: "KICHHA BARRIER" },
    { name: "BANBASA CHECKPOST" },
  ],
  westBengal: [
    { name: "PETRAPOLE ICP" },
    { name: "PHULBARI CHECKPOST" },
    { name: "HALDIBARI CHECKPOST" },
    { name: "DALKHOLA CHECKPOST" },
  ],
};

export const fields = {
  stateFieldsKeyMapping: {
    mp: "bihar",
    tamilNadu: "taminadu",
    uk: "uttrakhand",
  },
  stateName: {
    andhraPradesh: "ANDHRA PRADESH",
    ap: "ANDHRA PRADESH",
    arunachalPradesh: "ARUNACHAL PRADESH",
    ar: "ARUNACHAL PRADESH",
    assam: "ASSAM",
    bihar: "BIHAR",
    cg: "CHHATTISGARH",
    chhattisgarh: "CHHATTISGARH",
    damanDiu: "DAMAN & DIU",
    ga: "GOA",
    goa: "GOA",
    gj: "GUJARAT",
    gujarat: "GUJARAT",
    gujrat: "GUJARAT",
    haryana: "HARYANA",
    himachalPradesh: "HIMACHAL PRADESH",
    hp: "HIMACHAL PRADESH",
    jammuAndKashmir: "JAMMU AND KASHMIR",
    jk: "JAMMU AND KASHMIR",
    jh: "JHARKHAND",
    jharkhand: "JHARKHAND",
    ka: "KARNATAKA",
    karnataka: "KARNATAKA",
    kerala: "KERALA",
    kl: "KERALA",
    madhyaPradesh: "MADHYA PRADESH",
    mp: "MADHYA PRADESH",
    maharashtra: "MAHARASHTRA",
    manipur: "MANIPUR",
    meghalaya: "MEGHALAYA",
    mizoram: "MIZORAM",
    nagaland: "NAGALAND",
    odisha: "ODISHA",
    puducherry: "PUDUCHERRY",
    punjab: "PUNJAB",
    rajasthan: "RAJASTHAN",
    sikkim: "SIKKIM",
    tamilNadu: "TAMIL NADU",
    tn: "TAMIL NADU",
    telangana: "TELANGANA",
    tripura: "TRIPURA",
    uk: "UTTARAKHAND",
    uttarPradesh: "UTTAR PRADESH",
    uttarakhand: "UTTARAKHAND",
    up: "UTTAR PRADESH",
    wb: "WEST BENGAL",
    westBengal: "WEST BENGAL",
  },

  allState: [
    {
      name: "ANDHRA PRADESH",
      code: "andhra-pradesh",
      value: "ANDHRA PRADESH",
      label: "ANDHRA PRADESH",
    },
    {
      name: "ARUNACHAL PRADESH",
      code: "arunachal-pradesh",
      value: "ARUNACHAL PRADESH",
      label: "ARUNACHAL PRADESH",
    },
    { name: "ASSAM", code: "assam", value: "ASSAM", label: "ASSAM" },
    { name: "BIHAR", code: "bihar", value: "BIHAR", label: "BIHAR" },
    {
      name: "CHHATTISGARH",
      code: "chhattisgarh",
      value: "CHHATTISGARH",
      label: "CHHATTISGARH",
    },
    { name: "GOA", code: "goa", value: "GOA", label: "GOA" },
    { name: "GUJARAT", code: "gujarat", value: "GUJARAT", label: "GUJARAT" },
    { name: "HARYANA", code: "haryana", value: "HARYANA", label: "HARYANA" },
    {
      name: "JAMMU AND KASHMIR",
      code: "jammu-and-kashmir",
      value: "JAMMU AND KASHMIR",
      label: "JAMMU AND KASHMIR",
    },
    {
      name: "HIMACHAL PRADESH",
      code: "himachal-pradesh",
      value: "HIMACHAL PRADESH",
      label: "HIMACHAL PRADESH",
    },
    { name: "JHARKHAND", code: "jharkhand", value: "JHARKHAND", label: "JHARKHAND" },
    { name: "KARNATAKA", code: "karnataka", value: "KARNATAKA", label: "KARNATAKA" },
    { name: "KERALA", code: "kerala", value: "KERALA", label: "KERALA" },
    {
      name: "MADHYA PRADESH",
      code: "madhya-pradesh",
      value: "MADHYA PRADESH",
      label: "MADHYA PRADESH",
    },
    {
      name: "MAHARASHTRA",
      code: "maharashtra",
      value: "MAHARASHTRA",
      label: "MAHARASHTRA",
    },
    { name: "MANIPUR", code: "manipur", value: "MANIPUR", label: "MANIPUR" },
    { name: "MEGHALAYA", code: "meghalaya", value: "MEGHALAYA", label: "MEGHALAYA" },
    { name: "MIZORAM", code: "mizoram", value: "MIZORAM", label: "MIZORAM" },
    { name: "NAGALAND", code: "nagaland", value: "NAGALAND", label: "NAGALAND" },
    {
      name: "ODISHA",
      code: "odisha",
      value: "ODISHA",
      label: "ODISHA",
    },
    { name: "PUNJAB", code: "punjab", value: "PUNJAB", label: "PUNJAB" },
    { name: "RAJASTHAN", code: "rajasthan", value: "RAJASTHAN", label: "RAJASTHAN" },
    { name: "SIKKIM", code: "sikkim", value: "SIKKIM", label: "SIKKIM" },
    { name: "TAMIL NADU", code: "tamil-nadu", value: "TAMIL NADU", label: "TAMIL NADU" },
    { name: "TELANGANA", code: "telangana", value: "TELANGANA", label: "TELANGANA" },
    { name: "TRIPURA", code: "tripura", value: "TRIPURA", label: "TRIPURA" },
    {
      name: "UTTAR PRADESH",
      code: "uttar-pradesh",
      value: "UTTAR PRADESH",
      label: "UTTAR PRADESH",
    },
    { name: "UTTARAKHAND", code: "uttarakhand", value: "UTTARAKHAND", label: "UTTARAKHAND" },
    { name: "WEST BENGAL", code: "west-bengal", value: "WEST BENGAL", label: "WEST BENGAL" },
    { name: "PUDUCHERRY", code: "puducherry", value: "PUDUCHERRY", label: "PUDUCHERRY" },
    { name: "DAMAN & DIU", code: "daman-diu", value: "DAMAN & DIU", label: "DAMAN & DIU" },
  ],
  fromState: [
    {
      name: "Andaman and Nicobar Islands",
    },
    {
      name: "Andhra Pradesh",
    },
    {
      name: "Arunachal Pradesh",
    },
    {
      name: "Assam",
    },
    {
      name: "Bihar",
    },
    {
      name: "Chandigarh",
    },
    {
      name: "Chhattisgarh",
    },
    {
      name: "Dadra and Nagar Haveli",
    },
    {
      name: "Daman and Diu",
    },
    {
      name: "Delhi",
    },
    {
      name: "Goa",
    },
    {
      name: "Gujarat",
    },
    {
      name: "Haryana",
    },
    {
      name: "Himachal Pradesh",
    },
    {
      name: "Jammu and Kashmir",
    },
    {
      name: "Jharkhand",
    },
    {
      name: "Karnataka",
    },
    {
      name: "Kerala",
    },
    {
      name: "Lakshadweep",
    },
    {
      name: "Madhya Pradesh",
    },
    {
      name: "Maharashtra",
    },
    {
      name: "Manipur",
    },
    {
      name: "Meghalaya",
    },
    {
      name: "Mizoram",
    },
    {
      name: "Nagaland",
    },
    {
      name: "Odisha",
    },
    {
      name: "Puducherry",
    },
    {
      name: "Punjab",
    },
    {
      name: "Rajasthan",
    },
    {
      name: "Sikkim",
    },
    {
      name: "Tamil Nadu",
    },
    {
      name: "Telangana",
    },
    {
      name: "Tripura",
    },
    {
      name: "Uttar Pradesh",
    },
    {
      name: "Uttarakhand",
    },
    {
      name: "West Bengal",
    },
  ],
  taxMode: [
    {
      name: "DAYS",
    },
    {
      name: "WEEKLY",
    },
    {
      name: "MONTHLY",
    },
    {
      name: "QUARTERLY",
    },
  ],
  haryana: {
    vehiclePermitType: [
      {
        name: "CONTRACT CARRIAGE/PASSANGER VEHICLES",
      },
      {
        name: "PRIVATE SERVICE VEHICLE",
      },
      {
        name: "GOODS VEHICLE",
      },
      {
        name: "STAGE CARRIAGE",
      },
      {
        name: "CONSTRUCTION EQUIPMENT VEHICLE",
      },
    ],
    borderBarrier: [
      {
        name: "AMBALA",
      },
      { name: "BHIWANI" },
      { name: "CHARKHI DADRI" },
      { name: "FARIDABAD" },
      { name: "FATEHABAD" },
      { name: "GURUGRAM" },
      { name: "HISAR" },
      { name: "JHAJJAR" },
      { name: "JIND" },
      { name: "KAITHAL" },
      { name: "KARNAL" },
      { name: "KURUKSHETRA" },
      { name: "MAHENDRAGARH" },
      { name: "NUH" },
      { name: "PALWAL" },
      { name: "PANCHKULA" },
      { name: "PANIPAT" },
      { name: "REWARI" },
      { name: "ROHTAK" },
      { name: "SIRSA" },
      { name: "SONIPAT" },
      { name: "YAMUNA NAGAR" },
    ],
    serviceType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "ORDINARY",
      },
      {
        name: "AIR CONDITIONED",
      },
    ],
    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
    ],
  },
  bihar: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],

    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
    ],
    borderBarrier: [
      { name: "ARARIYA" },
      { name: "ARAWAL" },
      { name: "AURANGABAD" },
      { name: "BANKA" },
      { name: "BEGUSARAI" },
      { name: "BETTIAH" },
      { name: "BHABUA" },
      { name: "BHAGALPUR" },
      { name: "BHOJPUR" },
      { name: "BUXUR" },
      { name: "Chapara" },
      { name: "GOPALGANJ" },
      { name: "Patna" },
      { name: "Rohtash" },
      { name: "SAHARSHA" },
      { name: "SAMSTIPUR" },
      { name: "SHEIKHPURA" },
      { name: "SHEOHAR" },
      { name: "SITAMARIH" },
      { name: "SIWAN" },
      { name: "SUPAUL" },
      { name: "VAISHALI" },
    ],
    checkPostName: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
  },
  telangana: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],

    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
    ],
    borderBarrier: [
      { name: "ADILABAD" },
      { name: "BHADRADRI KOTHAGUDEM" },
      { name: "HYDERABAD" },
      { name: "JAGTIAL" },
      { name: "JANGAON" },
      { name: "JAYASHANKAR BHUPALPALLY" },
      { name: "JOGULAMBA GADWAL" },
      { name: "KAMAREDDY" },
      { name: "KARIMNAGAR" },
      { name: "KHAMMAM" },
      { name: "KOMARAM BHEEM ASIFABAD" },
      { name: "MAHABUBABAD" },
      { name: "MAHABUBNAGAR" },
      { name: "MANCHERIAL" },
      { name: "MEDAK" },
      { name: "MEDCHAL-MALKAJGIRI" },
      { name: "MULUGU" },
      { name: "NAGARKURNOOL" },
      { name: "NALGONDA" },
      { name: "NARAYANPET" },
      { name: "NIRMAL" },
      { name: "NIZAMABAD" },
      { name: "PEDDAPALLI" },
      { name: "RAJANNA SIRCILLA" },
      { name: "RANGA REDDY" },
      { name: "SANGAREDDY" },
      { name: "SIDDIPET" },
      { name: "SURYAPET" },
      { name: "VIKARABAD" },
      { name: "WANAPARTHY" },
      { name: "WARANGAL RURAL" },
      { name: "WARANGAL URBAN" },
      { name: "YADADRI BHUVANAGIRI" },
    ],
    checkPostName: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
  },
  assam: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],

    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
    ],
    borderBarrier: [
      { name: "BAKSA" },
      { name: "BAJALI" },
      { name: "BARPETA" },
      { name: "BISWANATH" },
      { name: "BONGAIGAON" },
      { name: "CACHAR" },
      { name: "CHARAIDEO" },
      { name: "CHIRANG" },
      { name: "DARRANG" },
      { name: "DHEMAJI" },
      { name: "DHUBRI" },
      { name: "DIBRUGARH" },
      { name: "DIMA HASAO" },
      { name: "GOALPARA" },
      { name: "GOLAGHAT" },
      { name: "HAILAKANDI" },
      { name: "HOJAI" },
      { name: "JORHAT" },
      { name: "KAMRUP" },
      { name: "KAMRUP METROPOLITAN" },
      { name: "KARBI ANGLONG" },
      { name: "KARIMGANJ" },
      { name: "KOKRAJHAR" },
      { name: "LAKHIMPUR" },
      { name: "MAJULI" },
      { name: "MORIGAON" },
      { name: "NAGAON" },
      { name: "NALBARI" },
      { name: "SIVASAGAR" },
      { name: "SONITPUR" },
      { name: "SOUTH SALMARA-MANKACHAR" },
      { name: "TINSUKIA" },
      { name: "UDALGURI" },
      { name: "WEST KARBI ANGLONG" },
    ],
    checkPostName: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    vehiclePermitType: [
      { name: "TRANSPORT" },
    ],
  },
  puducherry: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],

    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
    ],
    borderBarrier: [
      { name: "KARAIKAL" },
      { name: "MAHE" },
      { name: "PUDUCHERRY" },
      { name: "YANAM" },
    ],
    checkPostName: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
  },
  damanDiu: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],

    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
    ],
    borderBarrier: [
      { name: "DAMAN" },
      { name: "DIU" },
    ],
    checkPostName: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
  },
  sikkim: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],

    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
    ],
    borderBarrier: [
      { name: "GANGTOK" },
      { name: "GYALSHING" },
      { name: "MANGAN" },
      { name: "NAMCHI" },
      { name: "PAKYONG" },
      { name: "SORENG" },
    ],
    checkPostName: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
  },
  tripura: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],

    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
    ],
    borderBarrier: [
      { name: "DHALAI" },
      { name: "GOMATI" },
      { name: "KHOWAI" },
      { name: "NORTH TRIPURA" },
      { name: "SEPAHIJALA" },
      { name: "SOUTH TRIPURA" },
      { name: "UNAKOTI" },
      { name: "WEST TRIPURA" },
    ],
    checkPostName: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
  },
  jharkhand: {
    borderBarrier: [
      { name: "BOKARO" },
      { name: "CHATRA" },
      { name: "DEOGHAR" },
      { name: "DHANBAD" },
      { name: "DUMKA" },
      { name: "EAST SINGHBHUM (JAMSHEDPUR)" },
      { name: "GARHWA" },
      { name: "GIRIDIH" },
      { name: "GODDA" },
      { name: "GUMLA" },
      { name: "HAZARIBAGH" },
      { name: "JAMTARA" },
      { name: "KHUNTI" },
      { name: "KODERMA" },
      { name: "LATEHAR" },
      { name: "LOHARDAGA" },
      { name: "PAKUR" },
      { name: "PALAMU" },
      { name: "RAMGARH" },
      { name: "RANCHI" },
      { name: "SAHEBGANJ" },
      { name: "SARAIKELA-KHARSAWAN" },
      { name: "WEST SINGHBHUM (CHAIBASA)" },
    ],
    vehiclePermitType: [
      {
        name: "GOODS VEHICLE",
      },
      {
        name: "STAGE CARRIAGE",
      },
    ],
    permitType: [
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
    ],
  },
  karnataka: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    taxMode: [
      {
        name: "WEEKLY",
      },
      {
        name: "MONTHLY",
      },
    ],
    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
      {
        name: "NATIONAL PERMIT",
      },
    ],
    serviceType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "ORDINARY",
      },
      {
        name: "DELUXE AIR CONDITIONED",
      },
    ],
    borderBarrier: [
      { name: "ARTO,ALAND" },
      { name: "ARTO,ANMOD" },
      { name: "ARTO,ATTIBELE" },
      { name: "ARTO,BAGEPALI" },
      { name: "ARTO,DHOLKHED" },
      { name: "ARTO,GUNDLUPET" },
      { name: "ARTO,HAGARI" },
      { name: "ARTO,HUMNABAD" },
      { name: "ARTO,KAGAWADA" },
      { name: "ARTO,KOGNALI" },
      { name: "ARTO,NANGLI" },
      { name: "ARTO,PUNAJANPUR" },
      { name: "ARTO,TALAPADI" },
      { name: "GOWRIBIDANUR C.P" },
      { name: "RAYALPADU" },
    ],
    checkPostName: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
      { name: "CONSTRUCTION EQUIPMENT VEHICLE" },
    ],
  },
  odisha: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    taxMode: [
      {
        name: "DAYS",
      },
      {
        name: "WEEKLY",
      },
      {
        name: "MONTHLY",
      },
    ],
    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
      {
        name: "HOME STATE PERMIT",
      },
      {
        name: "NATIONAL PERMIT",
      },
    ],
    purposeOfJourney: [
      { name: "CARRYING GOODS" },
      { name: "CARRYING PASSENGER" },
    ],
    serviceType: [
      {
        name: "DELUX AIR CONDITIONED",
      },
      {
        name: "DELUX",
      },
      {
        name: "ORDINARY (3 X 2 SEATER)",
      },
      {
        name: "SLEEPER",
      },
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "ORDINARY",
      },
    ],
    enteringDistrict: [
      { name: "ANUGUL" },
      { name: "BALANGIR" },
      { name: "BALESHWAR" },
      { name: "BARGARH" },
      { name: "BAUDH" },
      { name: "BHADRAK" },
      { name: "CUTTACK" },
      { name: "DEBAGARH" },
      { name: "DHENKANAL" },
      { name: "GAJAPATI" },
      { name: "GANJAM" },
      { name: "JAGATSINGHAPUR" },
      { name: "JAJAPUR" },
      { name: "JHARSUGUDA" },
      { name: "KALAHANDI" },
      { name: "KANDHAMAL" },
      { name: "KENDRAPARA" },
      { name: "KENDUJHAR" },
      { name: "KHORDHA" },
      { name: "KORAPUT" },
      { name: "MALKANGIRI" },
      { name: "MAYURBHANJ" },
      { name: "NABARANGAPUR" },
      { name: "NAYAGARH" },
      { name: "NUAPADA" },
      { name: "PURI" },
      { name: "RAYAGADA" },
      { name: "SAMBALPUR" },
      { name: "STATE TRANSPORT AUTHORITY" },
      { name: "SUBARNAPUR" },
      { name: "SUNDARGARH" },
    ],

    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
      { name: "EDUCATIONAL INSTITUTIONAL BUS" },
      { name: "CONSTRUCTION EQUIPMENT VEHICLE" },
      { name: "PRIVATE VEHICLE" },
    ],
  },
  taminadu: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    taxMode: [
      {
        name: "DAYS",
      },
      {
        name: "WEEKLY",
      },
      {
        name: "MONTHLY",
      },
      {
        name: "YEARLY",
      },
    ],
    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
      {
        name: "HOME STATE PERMIT",
      },
      {
        name: "NATIONAL PERMIT",
      },
    ],

    rtoName: [
      {
        name: "COIMBATORE WEST",
      },
      {
        name: "GOBICHETTIPALAYAM",
      },
      {
        name: "HOSUR",
      },
      {
        name: "KRISHNAGIRI",
      },
      {
        name: "MARTHANDHAM",
      },
      {
        name: "OOTY",
      },
      {
        name: "PETHIKUPPAM",
      },
      {
        name: "POLLACHI",
      },
      {
        name: "POONAMALLEE",
      },
      {
        name: "TENKASI",
      },
      {
        name: "THENI",
      },
      {
        name: "THIRUVALLUR",
      },
      {
        name: "TINDIVANAM",
      },
      {
        name: "VELLORE",
      },
    ],

    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
      { name: "EDUCATIONAL INSTITUTIONAL BUS" },
      { name: "CONSTRUCTION EQUIPMENT VEHICLE" },
      { name: "PRIVATE VEHICLE" },
    ],
    borderBarrier: [],
  },
  kerala: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    taxMode: [
      {
        name: "DAYS",
      },
      {
        name: "WEEKLY",
      },
      {
        name: "MONTHLY",
      },
    ],
    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
      {
        name: "HOME STATE PERMIT",
      },
      {
        name: "NATIONAL PERMIT",
      },
    ],
    purposeOfJourney: [
      { name: "CARRYING GOODS" },
      { name: "CARRYING PASSENGER" },
    ],
    serviceType: [
      {
        name: "DELUX AIR CONDITIONED",
      },
      {
        name: "DELUX",
      },
      {
        name: "ORDINARY (3 X 2 SEATER)",
      },
      {
        name: "SLEEPER",
      },
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "ORDINARY",
      },
    ],
    enteringDistrict: [
      { name: "ANUGUL" },
      { name: "BALANGIR" },
      { name: "BALESHWAR" },
      { name: "BARGARH" },
      { name: "BAUDH" },
      { name: "BHADRAK" },
      { name: "CUTTACK" },
      { name: "DEBAGARH" },
      { name: "DHENKANAL" },
      { name: "GAJAPATI" },
      { name: "GANJAM" },
      { name: "JAGATSINGHAPUR" },
      { name: "JAJAPUR" },
      { name: "JHARSUGUDA" },
      { name: "KALAHANDI" },
      { name: "KANDHAMAL" },
      { name: "KENDRAPARA" },
      { name: "KENDUJHAR" },
      { name: "KHORDHA" },
      { name: "KORAPUT" },
      { name: "MALKANGIRI" },
      { name: "MAYURBHANJ" },
      { name: "NABARANGAPUR" },
      { name: "NAYAGARH" },
      { name: "NUAPADA" },
      { name: "PURI" },
      { name: "RAYAGADA" },
      { name: "SAMBALPUR" },
      { name: "STATE TRANSPORT AUTHORITY" },
      { name: "SUBARNAPUR" },
      { name: "SUNDARGARH" },
    ],

    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
      { name: "EDUCATIONAL INSTITUTIONAL BUS" },
      { name: "CONSTRUCTION EQUIPMENT VEHICLE" },
      { name: "PRIVATE VEHICLE" },
    ],
  },
  chhattisgarh: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    taxMode: [
      {
        name: "WEEKLY",
      },
      {
        name: "MONTHLY",
      },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
    permitType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
      {
        name: "SPECIAL PERMIT",
      },
    ],
    borderBarrier: [
      { name: "AMBIKAPUR RTO" },
      { name: "BAIKUNTHPUR DTO" },
      { name: "BALODA BAZAR DTO" },
      { name: "BALOD DTO" },
      { name: "BALRAMPUR DTO" },
      { name: "BEMETARA DTO" },
      { name: "BIJAPUR DTO" },
      { name: "BILASPUR RTO" },
      { name: "DANTEWADA DTO" },
      { name: "DHAMTARI DTO" },
      { name: "DURG RTO" },
      { name: "GARIYABAND DTO" },
      { name: "JAGDALPUR RTO" },
      { name: "JANJGIR CHAMPA DTO" },
      { name: "JASHPUR DTO" },
      { name: "KANKER DTO" },
      { name: "KAWARDHA DTO" },
      {
        name: "KONDAGAON DTO",
      },
      { name: "KORBA DTO" },
      { name: "MAHASAMUND DTO" },
      {
        name: "MUNGELI DTO",
      },
      { name: "NARAYANPUR DTO" },
      { name: "RAIGARH DTO" },
      {
        name: "RAIPUR RTO",
      },
      { name: "RAJNANDGAON RTO" },
      { name: "STATE TRANSPORT AUTHORITY" },
      { name: "SUKMA DTO" },
      { name: "SURAJPUR DTO" },
    ],
    serviceType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "ORDINARY",
      },
      {
        name: "DELUXE AIR CONDITIONED",
      },
    ],
  },
  uttrakhand: {
    vehiclePermitType: [
      {
        name: "CONTRACT CARRIAGE/PASSANGER VEHICLES",
      },
      {
        name: "GOODS VEHICLE",
      },
      {
        name: "CONSTRUCTION EQUIPMENT VEHICLE",
      },
    ],
    districtName: [
      { name: "DEHRADUN" },
      { name: "HARIDWAR" },
      { name: "KOTDWAR (DISTT. PAURI)" },
      { name: "UDHAM SINGH NAGAR" },
    ],

    permitType: [
      { name: "NOT APPLICABLE" },
      { name: "TEMPORARY PERMIT" },
      { name: "TOURIST PERMIT" },
      { name: "SPECIAL PERMIT" },
    ],
    serviceType: [
      { name: "AIR CONDITIONED" },
      { name: "ORDINARY" },
      { name: "NOT APPLICABLE" },
    ],
    barrierName: [
      {
        name: "ONE",
      },
    ],
  },
  up: {
    vehiclePermitType: [
      {
        name: "CONTRACT CARRIAGE/PASSANGER VEHICLES",
      },
      {
        name: "GOODS VEHICLE",
      },
    ],
    borderBarrier: [
      { name: "AGRA" },
      { name: "ALIGARH" },
      { name: "BAGHPAT" },
      { name: "BAHRAICH" },
      { name: "BALLIA" },
      { name: "BALRAMPUR" },
      { name: "BANDA" },
      { name: "BAREILLY" },
      { name: "BIJNOR" },
      { name: "CHANDAULI" },
      { name: "CHITRAKOOT" },
      { name: "DEORIA" },
      { name: "ETAWAH" },
      { name: "GAUTAM BUDDHA NAGAR" },
      { name: "GAZIABAD" },
      { name: "GHAZIPUR" },
      { name: "HAMIRPUR" },
      { name: "JHANSI" },
      { name: "KUSHINAGAR" },
      { name: "LAKHIMPUR" },
      { name: "LALITPUR" },
      { name: "MAHARAJGANJ" },
      { name: "MAHOBA" },
      { name: "MATHURA" },
      { name: "MIRZAPUR" },
      { name: "MUZAFFARNAGAR" },
      { name: "ORAI" },
    ],
    permitType: [
      { name: "NOT APPLICABLE" },
      { name: "TEMPORARY PERMIT" },
      { name: "TOURIST PERMIT" },
    ],

    serviceType: [
      {
        name: "ORDINARY",
      },
      {
        name: "AIR CONDITIONED",
      },
      {
        name: "NOT APPLICABLE",
      },
    ],
    taxMode: [
      {
        name: "DAYS",
      },
      {
        name: "MONTHLY",
      },
      {
        name: "QUARTERLY",
      },
    ],
  },
  punjab: {
    vehiclePermitType: [
      {
        name: "TRANSPORT",
      },
    ],
    borderBarrier: [
      { name: "BATHINDA" },
      { name: "FAZILKA" },
      { name: "MOHALI" },
      { name: "MUKTSAR" },
      { name: "PATHANKOT" },
      { name: "PATIALA" },
      { name: "RUPNAGAR" },
      { name: "SANGRUR" },
    ],
    checkPostName: [
      { name: "DOOMWALI" },
      { name: "GUMJAL" },
      { name: "RAJPURA" },
      { name: "JHARMARI" },
      { name: "KHARAR" },
      { name: "KILLIAN WALI" },
      { name: "MAMOON" },
      { name: "SHAMBU" },
      { name: "MOONAK" },
    ],
    permitType: [
      { name: "TEMPORARY PERMIT" },
      { name: "TOURIST PERMIT" },
      { name: "NATIONAL PERMIT" },
      { name: "NOT APPLICABLE" },
    ],

    serviceType: [
      { name: "Ordinary Service" },
      { name: 'Air Conditioned Service' },
      { name: 'AC Delux Service' },
      { name: "NOT APPLICABLE" },
    ],
  },
  gujrat: {
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    serviceType: [
      {
        name: "LUXURY",
      },
      {
        name: "ORDINARY",
      },
    ],
    ownerType: [
      {
        name: "INDIVIDUAL",
      },
      {
        name: "COMPANY",
      },
    ],
    makerStatus: [
      {
        name: "INDIAN",
      },
      {
        name: "IMPORTED",
      },
    ],
    permitType: [
      {
        name: "NOT APPLICABLE",
      },

      {
        name: "TOURIST PERMIT",
      },
      {
        name: "SPECIAL PERMIT",
      },
      {
        name: "SINGLE RETURN TRIP PERMIT",
      },
    ],
    borderBarrier: [
      { name: "AMBAJI" },
      { name: "AMIRGADH" },
      { name: "BHILAD" },
      { name: "CHHOTA UDEPUR" },
      { name: "DAHOD" },
      { name: "GUNDARI" },
      { name: "HAZIRA" },
      { name: "JAMNAGAR" },
      { name: "KAPRADA" },
      { name: "SAGBARA" },
      { name: "SAMKHIYALI" },
      { name: "SHAMLAJI" },
      { name: "SONGADH" },
      { name: "THARAD(KHODA)" },
      { name: "THAVAR" },
      { name: "WAGHAI" },
      { name: "ZOLAD" },
    ],
    checkPostName: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
      { name: "CONSTRUCTION EQUIPMENT VEHICLE" },
    ],
  },
  rajasthan: {
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
      { name: "TEMPORARY REGISTERED VEHICLES" },
      { name: "CONSTRUCTION EQUIPMENT VEHICLE" },
    ],
    borderBarrier: [
      { name: "ALWAR" },
      { name: "BANSWARA" },
      { name: "BARAN" },
      { name: "BHARATPUR" },
      { name: "CHITTORGARH" },
      { name: "CHURU" },
      { name: "DHOLPUR" },
      { name: "DUNGARPUR" },
      { name: "GANGANAGAR" },
      { name: "HANUMANGARH" },
      { name: "JAIPUR" },
      { name: "JALORE" },
      { name: "JHALAWAR" },
      { name: "JHUNJHUNU" },
      { name: "PRATAPGARH" },
      { name: "SIROHI" },
    ],

    serviceType: [
      {
        name: "NOT APPLICABLE",
      },
    ],
    permitType: [
      {
        name: "TEMPORARY PERMIT",
      },
      {
        name: "TOURIST PERMIT",
      },
      {
        name: "NOT APPLICABLE",
      },
    ],
    checkPostName: [
      {
        name: "AKERA MOD, ALWAR(ON BILASPUR - BHIWADI ROUTE)",
      },
      { name: "BHIWARI MOD, RADIWAS,BHIWADI(ON DHARUHEDA - BHIWADI ROUTE)" },
      { name: "DHARUHEDA MOD, BHIWARI(ON DHARUHEDA - BHIWADI ROUTE)" },
      { name: "NAREDA KALAN, ALWAR(ON NARNAUL - BEHROD ROUTE)" },
      { name: "NAVGAON, ALWAR(ON SOHNA - ALWAR ROUTE)" },
      { name: "PAKKA BAAG, ALWAR(ON AGRA - BHARATPUR ROUTE)" },
      { name: "SAHAJAHAPUR(ON GURGAON - JAIPUT ROUTE)" },
      { name: "TAWADU MOD, BHIWADI(ON SOHNA - BHIWADI ROUTE)" },
      { name: "BAHAJ, BHARATPUR(ON MATHURA - DEEG ROUTE)" },
      { name: "DHILAWATI, BHARATPUR(ON KOSHI - KAMAN ROUTE)" },
      { name: "JURHARA, KAMA(ON PUNHANA - KAMAN ROUTE)" },
      { name: "RARAH, BHARATPUR(ON MATHURA - BHARATPUR ROUTE)" },
      { name: "UNCHA NANGLA(ON AGRA - BHARATPUR ROUTE)" },
      { name: "NIMBEHERA, CHITTORGARH(ON NIMACH CHITTORGARH - DHOLPUR ROUTE)" },
      { name: "RAJGARH, CHURU(ON HISAR - RAJGARH - CHURU ROUTE)" },
      { name: "BARETHA, DHOLPUR(ON AGRA - DHOLPUR ROUTE)" },
      { name: "CHAMBAL, DHOLPUR(ON MURENA - DHOLPUR ROUTE)" },
      { name: "RATANPUR, DUNGARPUR(ON AHMEDABAD - UDAIPUR ROUTE)" },
      { name: "SIMMALWADA, DUNGARPUR(ON MODASA - DUNGARPUR ROUTE)" },
      { name: "BHADRA, HANUMANGARH(ON HISAR - HANUMANGARH ROUTE)" },
      { name: "SANGARIA, HANUMANGARH(ON DABWALI - HANUMANGARH ROUTE)" },
      { name: "GONERA, JAIPUR(ON NARNAUL - KOTPUTLI ROUTE)" },
      { name: "NAWATA KI DHANI, JHUNJHUNU(ON NARNAUL - JHUNJHUNU ROUTE)" },
      {
        name: "PILOD, JHUNJHUNU(ON NARNAUL - LAHURO SURAJGARH JHUNJHUNU ROUTE)",
      },
      { name: "PIPLI, JHUNJHUNU(ON LAHURO - PILANI JHUNJHUNU ROUTE)" },
      {
        name: "GOMATA, CHHOTI SHADRI, PRATAPGARH(ON NEEMACH - CHOTI SADRI ROUTE)",
      },
      { name: "PRATAPGARH(ON PRATAPGARH - MANSOR ROUTE)" },
      { name: "MANDAR, JALORE(ON PRATAPGARH - SIROHI ROUTE)" },
      { name: "DHANPUR, BANSWARA(ON Ratlam - Banswara Route)" },
      { name: "MONA DUNGAR, BANSWARA(on Jhalod - Banswara Route)" },
      { name: "KASBA THANA, BARAN(on Shivpuri - Baran Route)" },
      { name: "PATLI,S.GANGANAGAR(ON ABHOHAR-HANUMANGARH ROUTE)" },
      { name: "SADHUWALI,S.GANGANAGAR(ON ABHOHAR-HANUMANGARH ROUTE)" },
      { name: "MAKHUPURA, JALORE(on Dessa - Tharad - Barmer route)" },
      { name: "MANDARADI, JALORE(on Bansakantha - Bhinmal route)" },
      { name: "RAIPUR, JHALAWAR(on Soyag - Jhalawar route)" },
      { name: "TEENDHAR, TEEN-DHAR JALAWAR(on Rajgarh - Jhalawar route)" },
    ],
  },
  maharashtra: {
    serviceType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "ORDINARY",
      },
      {
        name: "AIR CONDITIONED",
      },
      {
        name: "ORDINARY (3 X 2 SEATER)",
      },
    ],
    permitType: [
      { name: "TEMPORARY PERMIT" },
      { name: "TOURIST PERMIT" },
      { name: "SPECIAL PERMIT" },
      { name: "NOT APPLICABLE" },
      { name: "NATIONAL PERMIT" },
    ],

    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE" },
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "PRIVATE SERVICE VEHICLE" },
      { name: "GOODS VEHICLE" },
      { name: "EDUCATIONAL INSTITUTIONAL BUS" },
      { name: "CONSTRUCTION EQUIPMENT VEHICLE" },
      { name: "VOLVO OR MARECEDEX ETC" },
      { name: "EDUCATION BUS" },
      { name: "2WHEELER" },
      { name: "EDUCATIONAL BUS USED BY SCHOOL" },
      { name: "PRIVATE ORGANIZATIONS" },
    ],
    vehicleClass: [
      { name: "3 WHEELER" },
      { name: "MOTOR CAB" },
      { name: "MAXI CAB" },
      { name: "OMNI BUS" },
      { name: "BUS" },
      { name: "EDUCATIONAL BUS" },
      { name: "LIGHT GOODS VEHICLE" },
      { name: "MEDIUM GOODS VEHICLE" },
      { name: "HEAVY GOODS VEHICLE" },
      { name: "SPECIAL" },
    ],
    checkPostName: [
      { name: "KHAPRI" },
      { name: "WARUD" },
      { name: "DEORI" },
      { name: "RAJURA" },
      { name: "PALASNER" },
      { name: "CHORWAD" },
      { name: "PURNAD" },
      { name: "KAGAL" },
      { name: "MANEGAON TEK" },
      { name: "NAWAPUR" },
      { name: "BORGAON" },
      { name: "OMERGA" },
      { name: "INSULI" },
      { name: "MANDRUP" },
      { name: "ACHAD" },
      { name: "PIMPALKUTTI" },
    ],
    borderBarrier: [
      { name: "AMRAVATI" },
      { name: "BHANDARA" },
      { name: "CHANDRAPUR" },
      { name: "DHULE" },
      { name: "JALGAON" },
      { name: "KOLHAPUR" },
      { name: "NAGPUR EAST" },
      { name: "NANDURBAR" },
      { name: "NASHIK" },
      { name: "OSMANABAD" },
      { name: "SINDHUDURG" },
      { name: "SOLAPUR" },
      { name: "THANE" },
      { name: "YAVATMAL" },
    ],
  },
  himachalPradesh: {
    serviceType: [
      {
        name: "NOT APPLICABLE",
      },
      {
        name: "ORDINARY",
      },
      {
        name: "AC(VOLVO ETC)",
      },
      {
        name: "DELUX NON AC(2X2)",
      },
      {
        name: "ORDINARY (3 X 2 SEATER)",
      },
    ],

    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],

    borderBarrier: [
      { name: "BADDI" },
      { name: "BAROTIWALA" },
      { name: "DAMTAL" },
      { name: "GAGRET" },
      { name: "KALAAMB" },
      { name: "KANDEAL" },
      { name: "MEHATPUR" },
      { name: "PAONTA SAHIB" },
      { name: "PARWANOO" },
      { name: "SWARGHAT" },
      { name: "TIPRA" },
      { name: "TUNUHATTI" },
    ],
  },
  ap: {

  /* =========================
     DISTRICT & CHECKPOST
  ========================= */

  districtName: [
    { name: "ALLURI SITHARAMA RAJU" },
    { name: "CHITTOOR" },
    { name: "ELURU" },
    { name: "KAKINADA" },
    { name: "KURNOOL" },
    { name: "NANDYAL" },
    { name: "NTR" },
    { name: "PALNADU" },
    { name: "TIRUPATI" },
    { name: "SRI SATHYA SAI" },
    { name: "SRIKAKULAM" }
  ],

  checkPostName: [
    { name: "CHITTI", district: "ALLURI SITHARAMA RAJU" },
    { name: "PALAMANER", district: "CHITTOOR" },
    { name: "NARAHARIPETA", district: "CHITTOOR" },
    { name: "JEELUGUMILLI", district: "ELURU" },
    { name: "KATHIPUDI", district: "KAKINADA" },
    { name: "KURNOOL", district: "KURNOOL" },
    { name: "SUNNIPENTA", district: "NANDYAL" },
    { name: "TIRUVURU", district: "NTR" },
    { name: "GARIKAPADU", district: "NTR" },
    { name: "MACHERLA", district: "PALNADU" },
    { name: "DACHEPALLI", district: "PALNADU" },
    { name: "RENIGUNTA", district: "TIRUPATI" },
    { name: "BHEEMUNIVARIPALEM", district: "TIRUPATI" },
    { name: "PENUKONDA", district: "SRI SATHYA SAI" },
    { name: "PURUSHOTHAPURAM", district: "SRIKAKULAM" }
  ],

  /* =========================
     VEHICLE TYPE
  ========================= */

  vehiclePermitType: [
    { name: "TRANSPORT" },
    { name: "NON-TRANSPORT" }
  ],

  /* =========================
     VEHICLE CLASS
  ========================= */

  vehicleClass: [

    /* -------- PASSENGER TRANSPORT -------- */

    { name: "OMNI BUS", category: "TRANSPORT", type: "PASSENGER" },
    { name: "BUS", category: "TRANSPORT", type: "PASSENGER" },
    { name: "EDUCATIONAL INSTITUTION BUS", category: "TRANSPORT", type: "PASSENGER" },
    { name: "MOTOR CAB", category: "TRANSPORT", type: "PASSENGER" },
    { name: "MAXI CAB", category: "TRANSPORT", type: "PASSENGER" },
    { name: "PRIVATE SERVICE VEHICLE", category: "TRANSPORT", type: "PASSENGER" },
    { name: "HEARSES", category: "TRANSPORT", type: "PASSENGER" },

    /* -------- GOODS TRANSPORT -------- */

    { name: "GOODS CARRIER", category: "TRANSPORT", type: "GOODS" },
    { name: "CASH VAN", category: "TRANSPORT", type: "GOODS" },
    { name: "POWER TILLER (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
    { name: "DUMPER", category: "TRANSPORT", type: "GOODS" },
    { name: "MULTI-AXLED GOODS", category: "TRANSPORT", type: "GOODS" },
    { name: "TRAILER (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
    { name: "SEMI-TRAILER (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
    { name: "MODULAR HYDRAULIC TRAILER", category: "TRANSPORT", type: "GOODS" },
    { name: "AUXILIARY TRAILER", category: "TRANSPORT", type: "GOODS" },
    { name: "TRACTOR-TROLLEY (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
    { name: "TRACTOR (COMMERCIAL)", category: "TRANSPORT", type: "GOODS" },
    { name: "CHASSIS OF VEHICLES", category: "TRANSPORT", type: "GOODS" },
    { name: "ARTICULATED VEHICLE", category: "TRANSPORT", type: "GOODS" },
    { name: "AMBULANCE", category: "TRANSPORT", type: "GOODS" },
    { name: "ANIMAL AMBULANCE", category: "TRANSPORT", type: "GOODS" },
    { name: "FIRE TENDERS", category: "TRANSPORT", type: "GOODS" },
    { name: "LIBRARY VAN", category: "TRANSPORT", type: "GOODS" },
    { name: "X-RAY VAN", category: "TRANSPORT", type: "GOODS" },
    { name: "MOBILE WORKSHOP", category: "TRANSPORT", type: "GOODS" },
    { name: "MOBILE CANTEEN", category: "TRANSPORT", type: "GOODS" },
    { name: "SNORKEL LADDERS", category: "TRANSPORT", type: "GOODS" },
    { name: "MOBILE CLINIC", category: "TRANSPORT", type: "GOODS" },

    /* -------- NON-TRANSPORT -------- */

    { name: "VEHICLE FITTED WITH RIG", category: "NON-TRANSPORT" },
    { name: "EARTH MOVING EQUIPMENT", category: "NON-TRANSPORT" },
    { name: "EXCAVATOR (NT)", category: "NON-TRANSPORT" },
    { name: "CRANE MOUNTED VEHICLE", category: "NON-TRANSPORT" },
    { name: "FORK LIFT", category: "NON-TRANSPORT" },
    { name: "VEHICLE FITTED WITH GENERATOR", category: "NON-TRANSPORT" },
    { name: "TREE TRIMMING VEHICLE", category: "NON-TRANSPORT" },
    { name: "CONSTRUCTION EQUIPMENT VEHICLE", category: "NON-TRANSPORT" },
    { name: "RECOVERY VEHICLE", category: "NON-TRANSPORT" },
    { name: "ROAD ROLLER", category: "NON-TRANSPORT" },
    { name: "TOWER WAGON", category: "NON-TRANSPORT" },
    { name: "BREAKDOWN VAN", category: "NON-TRANSPORT" },
    { name: "TOW TRUCK", category: "NON-TRANSPORT" },
    { name: "CAMPER VAN / TRAILER (PRIVATE USE)", category: "NON-TRANSPORT" },
    { name: "VEHICLE FITTED WITH COMPRESSOR", category: "NON-TRANSPORT" },
    { name: "ARMOURED / SPECIALISED VEHICLE", category: "NON-TRANSPORT" },
    { name: "QUADRICYCLE (PRIVATE)", category: "NON-TRANSPORT" },
    { name: "HARVESTER", category: "NON-TRANSPORT" },
    { name: "THREE WHEELER (PERSONAL)", category: "NON-TRANSPORT" },
    { name: "POWER TILLER", category: "NON-TRANSPORT" },
    { name: "TRAILER FOR PERSONAL USE", category: "NON-TRANSPORT" }
  ],

  /* =========================
     VEHICLE CATEGORY
  ========================= */

  passengerCategory: [
    { name: "LIGHT PASSENGER VEHICLE" },
    { name: "MEDIUM PASSENGER VEHICLE" },
    { name: "HEAVY PASSENGER VEHICLE" }
  ],

  goodsCategory: [
    { name: "LIGHT GOODS VEHICLE" },
    { name: "MEDIUM GOODS VEHICLE" },
    { name: "HEAVY GOODS VEHICLE" }
  ],

  nonTransportCategory: [
    { name: "LIGHT MOTOR VEHICLE" },
    { name: "MEDIUM MOTOR VEHICLE" },
    { name: "HEAVY MOTOR VEHICLE" }
  ],

  /* =========================
     OTHER DROPDOWNS
  ========================= */

  permitCategory: [
    { name: "REGULAR" },
    { name: "TEMPORARY" },
    { name: "SPECIAL" }
  ],

  permitType: [
    { name: "TEMPORARY PERMIT" },
    { name: "TOURIST PERMIT" },
    { name: "SPECIAL PERMIT" },
    { name: "NOT APPLICABLE" }
  ],

  serviceType: [
    { name: "ORDINARY" },
    { name: "AIR CONDITIONED" },
    { name: "Goods Service" },
    { name: "NOT APPLICABLE" }
  ],

  goodsName: [
    { name: "GENERAL GOODS" },
    { name: "CHEMICALS" },
    { name: "ELECTRONICS" },
    { name: "CONSUMER GOODS" },
    { name: "OTHERS" }
  ],

  taxMode: [
    { name: "DAILY" },
    { name: "WEEKLY" },
    { name: "MONTHLY" },
    { name: "QUARTERLY" },
    { name: "HALF YEARLY" },
    { name: "YEARLY" }
  ],

},

  andhraPradesh: {
    districtName: [
      { name: "ALLURI SITHARAMA RAJU" },
      { name: "ANAKAPALLE" },
      { name: "ANANTAPUR" },
      { name: "ANNAMAYYA" },
      { name: "BAPATLA" },
      { name: "CHITTOOR" },
      { name: "EAST GODAVARI" },
      { name: "ELURU" },
      { name: "GUNTUR" },
      { name: "KAKINADA" },
      { name: "KONASEEMA" },
      { name: "KRISHNA" },
      { name: "KURNOOL" },
      { name: "NANDYAL" },
      { name: "NTR" },
      { name: "PALNADU" },
      { name: "PARVATHIPURAM MANYAM" },
      { name: "PRAKASAM" },
      { name: "SRI POTTI SRIRAMULU NELLORE" },
      { name: "SRI SATHYA SAI" },
      { name: "SRIKAKULAM" },
      { name: "TIRUPATI" },
      { name: "VISAKHAPATNAM" },
      { name: "VIZIANAGARAM" },
      { name: "WEST GODAVARI" },
      { name: "YSR" },
    ],
    borderBarrier: [
      { name: "VISAKHAPATNAM" },
      { name: "VIJAYAWADA" },
      { name: "TIRUPATI" },
      { name: "KURNOOL" },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
    permitType: [{ name: "NOT APPLICABLE" }],
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    serviceType: [{ name: "NOT APPLICABLE" }],
  },
  arunachalPradesh: {
    districtName: [
      { name: "ANJAW" },
      { name: "CHANGLANG" },
      { name: "DIBANG VALLEY" },
      { name: "EAST KAMENG" },
      { name: "EAST SIANG" },
      { name: "KAMLE" },
      { name: "KRA DAADI" },
      { name: "KURUNG KUMEY" },
      { name: "LEPARADA" },
      { name: "LOHIT" },
      { name: "LONGDING" },
      { name: "LOWER DIBANG VALLEY" },
      { name: "LOWER SIANG" },
      { name: "LOWER SUBANSIRI" },
      { name: "NAMSAI" },
      { name: "PAPUM PARE" },
      { name: "PAKKE KESSANG" },
      { name: "SHI YOMI" },
      { name: "SIANG" },
      { name: "TAWANG" },
      { name: "TIRAP" },
      { name: "UPPER SIANG" },
      { name: "UPPER SUBANSIRI" },
      { name: "WEST KAMENG" },
      { name: "WEST SIANG" },
    ],
    borderBarrier: [
      { name: "ITANAGAR" },
      { name: "TAWANG" },
      { name: "PASIGHAT" },
      { name: "ZIRO" },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
    permitType: [{ name: "NOT APPLICABLE" }],
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    serviceType: [{ name: "NOT APPLICABLE" }],
  },
  goa: {
    districtName: [
      { name: "NORTH GOA" },
      { name: "SOUTH GOA" },
    ],
    borderBarrier: [
      { name: "NORTH GOA" },
      { name: "SOUTH GOA" },
      { name: "PANAJI" },
      { name: "MARGAO" },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
    permitType: [{ name: "NOT APPLICABLE" }],
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    serviceType: [{ name: "NOT APPLICABLE" }],
  },
  manipur: {
    districtName: [
      { name: "BISHNUPUR" },
      { name: "CHANDEL" },
      { name: "CHURACHANDPUR" },
      { name: "IMPHAL EAST" },
      { name: "IMPHAL WEST" },
      { name: "JIRIBAM" },
      { name: "KAKCHING" },
      { name: "KAMJONG" },
      { name: "KANGPOKPI" },
      { name: "NONEY" },
      { name: "PHERZAWL" },
      { name: "SENAPATI" },
      { name: "TAMENGLONG" },
      { name: "TENGNOUPAL" },
      { name: "THOUBAL" },
      { name: "UKHRUL" },
    ],
    borderBarrier: [
      { name: "IMPHAL WEST" },
      { name: "IMPHAL EAST" },
      { name: "THOUBAL" },
      { name: "CHANDEL" },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
    permitType: [{ name: "NOT APPLICABLE" }],
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    serviceType: [{ name: "NOT APPLICABLE" }],
  },
  meghalaya: {
    districtName: [
      { name: "EAST GARO HILLS" },
      { name: "EAST JAINTIA HILLS" },
      { name: "EAST KHASI HILLS" },
      { name: "EASTERN WEST KHASI HILLS" },
      { name: "NORTH GARO HILLS" },
      { name: "RI BHOI" },
      { name: "SOUTH GARO HILLS" },
      { name: "SOUTH WEST GARO HILLS" },
      { name: "SOUTH WEST KHASI HILLS" },
      { name: "WEST GARO HILLS" },
      { name: "WEST JAINTIA HILLS" },
      { name: "WEST KHASI HILLS" },
    ],
    borderBarrier: [
      { name: "EAST KHASI HILLS" },
      { name: "WEST KHASI HILLS" },
      { name: "WEST JAINTIA HILLS" },
      { name: "WEST GARO HILLS" },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
    permitType: [{ name: "NOT APPLICABLE" }],
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    serviceType: [{ name: "NOT APPLICABLE" }],
  },
  mizoram: {
    districtName: [
      { name: "AIZAWL" },
      { name: "CHAMPHAI" },
      { name: "HNAHTHIAL" },
      { name: "KHAWZAWL" },
      { name: "KOLASIB" },
      { name: "LAWNGTLAI" },
      { name: "LUNGLEI" },
      { name: "MAMIT" },
      { name: "SAITUAL" },
      { name: "SAIHA" },
      { name: "SERCHHIP" },
    ],
    borderBarrier: [
      { name: "AIZAWL" },
      { name: "LUNGLEI" },
      { name: "KOLASIB" },
      { name: "CHAMPHAI" },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
    permitType: [{ name: "NOT APPLICABLE" }],
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    serviceType: [{ name: "NOT APPLICABLE" }],
  },
  nagaland: {
    districtName: [
      { name: "CHUMOUKEDIMA" },
      { name: "DIMAPUR" },
      { name: "KIPHIRE" },
      { name: "KOHIMA" },
      { name: "LONGLENG" },
      { name: "MOKOKCHUNG" },
      { name: "MON" },
      { name: "NIULAND" },
      { name: "NOKLAK" },
      { name: "PEREN" },
      { name: "PHEK" },
      { name: "SHAMATOR" },
      { name: "TUENSANG" },
      { name: "TSEMINYU" },
      { name: "WOKHA" },
      { name: "ZUNHEBOTO" },
    ],
    borderBarrier: [
      { name: "DIMAPUR" },
      { name: "KOHIMA" },
      { name: "MOKOKCHUNG" },
      { name: "MON" },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
    permitType: [{ name: "NOT APPLICABLE" }],
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    serviceType: [{ name: "NOT APPLICABLE" }],
  },
  westBengal: {
    districtName: [
      { name: "ALIPURDUAR" },
      { name: "BANKURA" },
      { name: "BIRBHUM" },
      { name: "COOCH BEHAR" },
      { name: "DAKSHIN DINAJPUR" },
      { name: "DARJEELING" },
      { name: "HOOGHLY" },
      { name: "HOWRAH" },
      { name: "JALPAIGURI" },
      { name: "JHARGRAM" },
      { name: "KALIMPONG" },
      { name: "KOLKATA" },
      { name: "MALDA" },
      { name: "MURSHIDABAD" },
      { name: "NADIA" },
      { name: "NORTH 24 PARGANAS" },
      { name: "PASCHIM BARDHAMAN" },
      { name: "PASCHIM MEDINIPUR" },
      { name: "PURBA BARDHAMAN" },
      { name: "PURBA MEDINIPUR" },
      { name: "PURULIA" },
      { name: "SOUTH 24 PARGANAS" },
      { name: "UTTAR DINAJPUR" },
    ],
    borderBarrier: [
      { name: "KOLKATA" },
      { name: "HOWRAH" },
      { name: "DARJEELING" },
      { name: "SILIGURI" },
    ],
    vehiclePermitType: [
      { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
      { name: "GOODS VEHICLE" },
    ],
    permitType: [{ name: "NOT APPLICABLE" }],
    paymentMode: [{ name: "CASH" }, { name: "ONLINE" }],
    serviceType: [{ name: "NOT APPLICABLE" }],
  },
};

// --- SAFEGUARDS FOR BIHAR (only add if missing) ---
fields.bihar = fields.bihar || {};
fields.bihar.vehiclePermitType = fields.bihar.vehiclePermitType || [{ name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" }, { name: "GOODS VEHICLE" }];
fields.bihar.paymentMode = fields.bihar.paymentMode || [{ name: "CASH" }, { name: "ONLINE" }];
fields.bihar.permitType = fields.bihar.permitType || [{ name: "TOURIST" }, { name: "OTHER" }];
fields.bihar.borderBarrier = fields.bihar.borderBarrier || [{ name: "PATNA" }, { name: "GAYA" }];
fields.bihar.checkPostName = fields.bihar.checkPostName || [{ name: "PATNA CHECKPOST" }, { name: "GAYA CHECKPOST" }];

// --- SAFEGUARDS FOR JHARKHAND (only add if missing) ---
fields.jharkhand = fields.jharkhand || {};
fields.jharkhand.vehiclePermitType = fields.jharkhand.vehiclePermitType || [{ name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" }, { name: "GOODS VEHICLE" }];
fields.jharkhand.permitType = fields.jharkhand.permitType || [{ name: "TOURIST" }];
fields.jharkhand.borderBarrier = fields.jharkhand.borderBarrier || [{ name: "RANCHI" }];
fields.jharkhand.checkPostName = fields.jharkhand.checkPostName || [{ name: "RANCHI CHECKPOST" }];
fields.jharkhand.serviceType = fields.jharkhand.serviceType || [{ name: "Tourist" }];

// ---------------- SAFEGUARDS FOR STATES ----------------
// Add this after your `fields` object is defined. It will NOT
// overwrite existing data — only provide defaults if missing.

fields.karnataka = fields.karnataka || {};
fields.karnataka.vehiclePermitType = fields.karnataka.vehiclePermitType || [
  { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
  { name: "GOODS VEHICLE" }
];
fields.karnataka.permitType = fields.karnataka.permitType || [
  { name: "TOURIST PERMIT" },
  { name: "NATIONAL PERMIT" }
];
fields.karnataka.borderBarrier = fields.karnataka.borderBarrier || [
  { name: "BENGALURU" }
];
fields.karnataka.checkPostName = fields.karnataka.checkPostName || [
  { name: "BENGALURU CHECKPOST", district: "BENGALURU" }
];
fields.karnataka.serviceType = fields.karnataka.serviceType || [
  { name: "Tourist" }
];
fields.karnataka.taxMode = fields.karnataka.taxMode || fields.taxMode || [
  { name: "ANNUAL" },
  { name: "MONTHLY" }
];

// ---------------- Kerala ----------------
fields.kerala = fields.kerala || {};

fields.kerala.paymentMode = fields.kerala.paymentMode || [
  { name: "CASH" },
  { name: "ONLINE" },
];

fields.kerala.fuelType = fields.kerala.fuelType || [
  { name: "CNG only" },
  { name: "Diesel" },
  { name: "Diesel/Hybrid" },
  { name: "Electric(BOV)" },
  { name: "Ethanol" },
  { name: "LPG Only" },
  { name: "Others" },
  { name: "Petrol" },
  { name: "Petrol/CNG" },
  { name: "Petrol/Hybrid" },
  { name: "Petrol/LPG" },
  { name: "SOLAR" }
];

fields.kerala.goodsName = fields.kerala.goodsName || [
  { name: "Not Applicable" },
  { name: "Rice" },
  { name: "Wheat" },
  { name: "Flour" },
  { name: "Pulses" },
  { name: "Sugar" },
  { name: "Salt" },
  { name: "Milk" },
  { name: "Edible Oil" }
];

fields.kerala.registrationType = fields.kerala.registrationType || [
  { name: "Ex Army/Auction vehicle" },
  { name: "New Regn Against Auction/Confiscated vehicle" },
  { name: "CD/Embassy/Foreign Vehicle" },
  { name: "New" },
  { name: "Other State Vehicle" },
  { name: "Other RTC/MLO/Artc/DTO/Region vehicle" },
  { name: "New regn Against scrapped vehicle" },
  { name: "TEMPORARY REGISTERED VEHICLE" }
];

fields.kerala.taxMode = fields.kerala.taxMode || [
  { name: 'WEEKLY' },
  { name: 'MONTHLY' }
];

fields.kerala.permitType = fields.kerala.permitType || [
  { name: 'NOT APPLICABLE', category: "" },
  { name: 'CONTRACT CARRIAGE PERMIT', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'All INDIA TOURIST PERMIT', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'Goods permit', category: 'GOODS VEHICLE' }
];

fields.kerala.permit = fields.kerala.permit || [
  { name: "EV Permit", category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'TEMPORARY Permit', category: 'GOODS VEHICLE' }
];

fields.kerala.vehicleCategory = fields.kerala.vehicleCategory || [
  { name: 'NOT APPLICABLE', category: '' },
  { name: 'LIGHT PASSANGER VEHICLE', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'HEAVY PASSANGER VEHICLE', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'MEDIUM PASSANGER VEHICLE', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'HEAVY Goods vehicle', category: 'GOODS VEHICLE' },
  { name: 'LIGHT Goods vehicle', category: 'GOODS VEHICLE' },
  { name: 'MEDIUM Goods vehicle', category: 'GOODS VEHICLE' }
];

fields.kerala.permitCategory = fields.kerala.permitCategory || [
  { name: 'NOT APPLICABLE', category: '' },
  { name: 'Motor cab permit', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'All India TOURIST OMNI BUS Permit', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'Goods CARRIERS', category: 'GOODS VEHICLE' },
  { name: 'Tipper', category: 'GOODS VEHICLE' }
];

fields.kerala.purposeOfJourney = fields.kerala.purposeOfJourney || [
  { name: 'CARRYING GOODS' },
  { name: 'CARRYING PASSANGER' }
];

fields.kerala.serviceType = fields.kerala.serviceType || [
  { name: 'ORDINARY SERVICE' },
  { name: 'AIR CONDITIONED SERVICE' },
  { name: 'Night Service' },
  { name: 'SLEEPER AC Service' },
  { name: 'Sleeper NON-AC Service' },
  { name: 'LUXURY Service' },
  { name: 'Super-Luxury Service' },
  { name: 'Sleeper Super-Luxury Service' },
  { name: 'Rural Service' },
  { name: 'Within Municipal Area' },
  { name: 'Outside Municipal Area' },
  { name: 'Goods Service' },
  { name: 'Express Service' },
  { name: 'SPECIAL Service(Minibus)' },
  { name: 'Limited Service' },
  { name: 'Inter state Service' },
  { name: 'Intra state Service' },
  { name: 'Rural' },
  { name: 'Urban' },
  { name: 'Sub-Urban' },
  { name: 'Other' },
  { name: 'AC DELUXE Service' },
  { name: 'AC DELUXE Sleeper Service' },
  { name: 'DELUXE Service' },
  { name: 'Integral Buses' },
  { name: 'Super Integral Buses' },
  { name: 'Ghat Section' },
  { name: 'Public Carrier' },
  { name: 'PRIVATE Carrier' },
  { name: 'Semi-Deluxe Service' },
  { name: 'Metropolitan Area' },
  { name: 'Town/City Service' },
  { name: 'Mofussil Service' },
  { name: 'Bazar Service' }
];

fields.kerala.tipperBody = fields.kerala.tipperBody || [
  { name: "Not Applicable" },
  { name: "Yes" },
  { name: "No" }
];

fields.kerala.districtName = fields.kerala.districtName || [
  { name: 'IDUKKI' },
  { name: 'KANNUR' },
  { name: 'KASARGODE' },
  { name: 'KOLLAM' },
  { name: 'MALAPPURAM' },
  { name: 'PALAKKAD' },
  { name: 'THIRUVANANTHAPURAM' },
  { name: 'WAYANAD' }
];

fields.kerala.checkPostName = fields.kerala.checkPostName || [
  // IDUKKI
  { name: 'KUMILI', district: 'IDUKKI' },

  // KANNUR
  { name: 'IRITTY', district: 'KANNUR' },

  // KASARGODE
  { name: 'MANJESWARAM-Thalapady', district: 'KASARGODE' },
  { name: 'NEELESWARAM', district: 'KASARGODE' },
  { name: 'PERLA-Adkadsthala', district: 'KASARGODE' },

  // KOLLAM
  { name: 'ARYANKAVU', district: 'KOLLAM' },

  // MALAPPURAM
  { name: 'VAZHIKKADAVU', district: 'MALAPPURAM' },

  // PALAKKAD
  { name: 'GOPALAPURAM', district: 'PALAKKAD' },
  { name: 'GOVINDAPURAM', district: 'PALAKKAD' },
  { name: 'MEENAKSHIPURAM', district: 'PALAKKAD' },
  { name: 'NADUPPUNI', district: 'PALAKKAD' },
  { name: 'VALAYAR IN', district: 'PALAKKAD' },
  { name: 'VALAYAR OUT', district: 'PALAKKAD' },
  { name: 'VELANTHAVALAM', district: 'PALAKKAD' },

  // THIRUVANANTHAPURAM
  { name: 'AMARAVILA (IN)', district: 'THIRUVANANTHAPURAM' },
  { name: 'KURUMKUTTY (AMARAVILA-OUT)', district: 'THIRUVANANTHAPURAM' },
  { name: 'POOVAR', district: 'THIRUVANANTHAPURAM' },

  // WAYANAD
  { name: 'BATHERI (MUTHANGA)', district: 'WAYANAD' },
  { name: 'KATTIKULAM', district: 'WAYANAD' }
];

fields.kerala.enteringDistrict = fields.kerala.enteringDistrict || [
  { name: 'ANUGUL' },
  { name: 'BALANGIR' },
  { name: 'BALESHWAR' },
  { name: 'BARGARH' },
  { name: 'BAUDH' },
  { name: 'BHADRAK' },
  { name: 'CUTTACK' },
  { name: 'DEBAGARH' },
  { name: 'DHENKANAL' },
  { name: 'GAJAPATI' },
  { name: 'GANJAM' },
  { name: 'JAGATSINGHAPUR' },
  { name: 'JAJAPUR' },
  { name: 'JHARSUGUDA' },
  { name: 'KALAHANDI' },
  { name: 'KANDHAMAL' },
  { name: 'KENDRAPARA' },
  { name: 'KENDUJHAR' },
  { name: 'KHORDHA' },
  { name: 'KORAPUT' },
  { name: 'MALKANGIRI' },
  { name: 'MAYURBHANJ' },
  { name: 'NABARANGAPUR' },
  { name: 'NAYAGARH' },
  { name: 'NUAPADA' },
  { name: 'PURI' },
  { name: 'RAYAGADA' },
  { name: 'SAMBALPUR' },
  { name: 'STATE TRANSPORT AUTHORITY' },
  { name: 'SUBARNAPUR' },
  { name: 'SUNDARGARH' }
];

fields.kerala.vehiclePermitType = fields.kerala.vehiclePermitType || [
  { name: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'GOODS VEHICLE' },
  { name: 'CONSTRUCTION EQUIPMENT VEHICLE' }
];

fields.kerala.vehicleClass = fields.kerala.vehicleClass || [
  // CONTRACT CARRIAGE / PASSANGER VEHICLES
  { name: 'MOTOR CAB', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'MAXI CAB', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'OMNI BUS', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'BUS', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'EDUCATIONAL BUS', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'MOTOR CYCLE/SCOOTER USED FOR HIRE', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },
  { name: 'QUADRICYCLE(COMMERCIAL)', category: 'CONTRACT CARRIAGE/PASSANGER VEHICLES' },

  // GOODS VEHICLE
  { name: 'THREE WHEELER(GOODS)', category: 'GOODS VEHICLE' },
  { name: 'TRAILER', category: 'GOODS VEHICLE' },
  { name: 'MOBILE CANTEEN', category: 'GOODS VEHICLE' },
  { name: 'LIBRARY VAN', category: 'GOODS VEHICLE' },
  { name: 'MOBILE CLINIC', category: 'GOODS VEHICLE' },
  { name: 'X-RAY VAN', category: 'GOODS VEHICLE' },
  { name: 'CASH VAN', category: 'GOODS VEHICLE' },
  { name: 'ARTICULATED VEHICLE', category: 'GOODS VEHICLE' },
  { name: 'CAMPER VAN/TRAILER', category: 'GOODS VEHICLE' },
  { name: 'GOOD CARRIERS', category: 'GOODS VEHICLE' },
  { name: 'DUMPER', category: 'GOODS VEHICLE' },

  // CONSTRUCTION EQUIPMENT VEHICLE
  { name: 'BREAKDOWN VAN', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'CONSTRUCTION EQUIPMENT VEHICLE', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'VEHICLE FITTED WITH RIG', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'VEHICLE FITTED WITH COMPRESSOR', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'CRANE MOUNTED VEHICLE', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'FORK LIFT', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'VEHICLE FITTED WITH AIR GENERATOR', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'HARVESTER', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'AMBULANCE', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'EXCAVATOR', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'EARTH MOVING EQUIPMENT', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'RECOVERY VEHICLE', category: 'CONSTRUCTION EQUIPMENT VEHICLE' },
  { name: 'TOW TRUCK', category: 'CONSTRUCTION EQUIPMENT VEHICLE' }
];


// ---------------- Madhya Pradesh (mp) ----------------
fields.mp = fields.mp || {};

// Payment / tax / service / permit basics
fields.mp.paymentMode = fields.mp.paymentMode || [{ name: "CASH" }, { name: "ONLINE" }];
fields.mp.taxMode = fields.mp.taxMode || fields.taxMode || [
  { name: "DAYS" },
  { name: "WEEKLY" },
  { name: "MONTHLY" },
  { name: "QUARTERLY" },
  { name: "ANNUAL" },
];

fields.mp.serviceType = fields.mp.serviceType || [
  { name: "NOT APPLICABLE" },
  { name: "ORDINARY" },
  { name: "DELUXE AIR CONDITIONED" },
  { name: "SLEEPER" },
  { name: "AIR CONDITIONED" },
];

// Vehicle / permit options
// ✅ MP: Vehicle Type (as per portal dropdown)
fields.mp.vehiclePermitType = fields.mp.vehiclePermitType || [
  { name: "CONTRACT CARRIAGE/PASSENGER VEHICLES" },
  { name: "GOODS VEHICLE" },
  { name: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "TEMPORARY REGISTERED VEHICLES/VEHICLE ON TRADE CERTIFICATE NUMBER" },
];

// ✅ MP: Vehicle Class (as per portal dropdown lists shown in your screenshots)
// Note: keep `category` exactly matching `vehiclePermitType` values above.
fields.mp.vehicleClass = fields.mp.vehicleClass || [
  // ================= CONTRACT CARRIAGE/PASSENGER VEHICLES =================
  { name: "THREE WHEELER(PASSENGER)", category: "CONTRACT CARRIAGE/PASSENGER VEHICLES" },
  { name: "MOTOR CAB", category: "CONTRACT CARRIAGE/PASSENGER VEHICLES" },
  { name: "LUXURY CAB", category: "CONTRACT CARRIAGE/PASSENGER VEHICLES" },
  { name: "MAXI CAB", category: "CONTRACT CARRIAGE/PASSENGER VEHICLES" },
  { name: "OMNI BUS", category: "CONTRACT CARRIAGE/PASSENGER VEHICLES" },
  { name: "BUS", category: "CONTRACT CARRIAGE/PASSENGER VEHICLES" },

  // ================= GOODS VEHICLE =================
  { name: "THREE WHEELER(GOODS)", category: "GOODS VEHICLE" },
  { name: "LIGHT GOODS VEHICLE", category: "GOODS VEHICLE" },
  { name: "MEDIUM GOODS VEHICLE", category: "GOODS VEHICLE" },
  { name: "HEAVY GOODS VEHICLE", category: "GOODS VEHICLE" },
  { name: "TRAILER", category: "GOODS VEHICLE" },
  { name: "MOBILE CANTEEN", category: "GOODS VEHICLE" },
  { name: "LIBRARY VAN", category: "GOODS VEHICLE" },
  { name: "MOBILE WORKSHOP", category: "GOODS VEHICLE" },
  { name: "MOBILE CLINIC", category: "GOODS VEHICLE" },
  { name: "X-RAY VAN", category: "GOODS VEHICLE" },
  { name: "CASH VAN", category: "GOODS VEHICLE" },
  { name: "ARTICULATED VEHICLE", category: "GOODS VEHICLE" },
  { name: "CAMPER VAN / TRAILER", category: "GOODS VEHICLE" },
  { name: "MULTI-AXLED GOODS", category: "GOODS VEHICLE" },
  { name: "GOODS CARRIERS", category: "GOODS VEHICLE" },
  { name: "DUMPER", category: "GOODS VEHICLE" },

  // ================= CONSTRUCTION EQUIPMENT VEHICLE =================
  // (your screenshot shows these under vehicle class list)
  { name: "CONSTRUCTION EQUIPMENT VEHICLE", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "CHASSIS OF VEHICLES", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "VEHICLE FITTED WITH RIG", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "VEHICLE FITTED WITH COMPRESSOR", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "CRANE MOUNTED VEHICLE", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "TOWER WAGONS", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "TREE TRIMMING VEHICLE", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "FORK LIFT", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "VEHICLE FITTED WITH AIR GENERATOR", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "EXCAVATOR", category: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "EARTH MOVING EQUIPMENT", category: "CONSTRUCTION EQUIPMENT VEHICLE" },

  // ================= TEMPORARY REGISTERED VEHICLES/VEHICLE ON TRADE CERTIFICATE NUMBER =================
  // (these appeared in your class dropdown panel screenshot)
  { name: "BUS", category: "TEMPORARY REGISTERED VEHICLES/VEHICLE ON TRADE CERTIFICATE NUMBER" },
  { name: "CONSTRUCTION EQUIPMENT VEHICLE", category: "TEMPORARY REGISTERED VEHICLES/VEHICLE ON TRADE CERTIFICATE NUMBER" },
  { name: "AGRICULTURAL TRACTOR", category: "TEMPORARY REGISTERED VEHICLES/VEHICLE ON TRADE CERTIFICATE NUMBER" },
  { name: "HARVESTER", category: "TEMPORARY REGISTERED VEHICLES/VEHICLE ON TRADE CERTIFICATE NUMBER" },
  { name: "AMBULANCE", category: "TEMPORARY REGISTERED VEHICLES/VEHICLE ON TRADE CERTIFICATE NUMBER" },
  { name: "GOODS CARRIERS", category: "TEMPORARY REGISTERED VEHICLES/VEHICLE ON TRADE CERTIFICATE NUMBER" },
  { name: "DUMPER", category: "TEMPORARY REGISTERED VEHICLES/VEHICLE ON TRADE CERTIFICATE NUMBER" },
];

// common goods/fuel/registration lists (small sets; expand as needed)
fields.mp.goodsName = fields.mp.goodsName || [
  { name: "GENERAL GOODS" },
  { name: "FOOD ITEMS" },
  { name: "CONSTRUCTION MATERIALS" },
  { name: "CHEMICALS" },
  { name: "ELECTRONICS" },
  { name: "OTHERS" },
];

fields.mp.fuelType = fields.mp.fuelType || [
  { name: "PETROL" },
  { name: "DIESEL" },
  { name: "CNG" },
  { name: "LPG" },
  { name: "ELECTRIC" },
  { name: "HYBRID" },
];

fields.mp.registrationType = fields.mp.registrationType || [
  { name: "PRIVATE" },
  { name: "COMMERCIAL" },
  { name: "TEMPORARY REGISTERED VEHICLE" },
];

// Districts (major MP districts - extend as needed)
fields.mp.districtName = fields.mp.districtName || [
  { name: "BHOPAL" },
  { name: "INDORE" },
  { name: "JABALPUR" },
  { name: "GWALIOR" },
  { name: "REWA" },
  { name: "MORENA" },
  { name: "BETUL" },
  { name: "SENDHWA" },
  { name: "SATNA" },
  { name: "UJJAIN" },
  { name: "GWALIOR" },
  { name: "VIDISHA" },
  { name: "RATLAM" },
  { name: "CHHINDWARA" },
  { name: "DEWAS" },
];

// Border / barrier list (common MP border checkposts / RTOs)
fields.mp.borderBarrier = fields.mp.borderBarrier || [
      { name: 'AGAR MALWA' },
      { name: 'ALIRAJPUR' },
      { name: 'ANUPPUR' },
      { name: 'ASHOK NAGAR' },
      { name: 'BALAGHAT' },
      { name: 'BARWANI' },
      { name: 'BETUL' },
      { name: 'BHIND' },
      { name: 'BURHANPUR' },
      { name: 'CHHATARPUR' },
      { name: 'CHHINDWARA' },
      { name: 'DATIA' },
      { name: 'DINDORI' },
      { name: 'GUNA' },
      { name: 'GWALIOR' },
      { name: 'JHABUA' },
      { name: 'MANDLA' },
      { name: 'MANDSAUR' },
      { name: 'MORENA' },
      { name: 'NEEMUCH' },
      { name: 'RAJGARH' },
      { name: 'RATLAM' },
      { name: 'REWA' },
      { name: 'SAGAR' },
      { name: 'SATNA' },
      { name: 'SEONI' },
      { name: 'SHEOPUR' },
      { name: 'SHIVPURI' },
      { name: 'SINGRAULI' },
    ];

// checkPostName with district so UI can filter by selected district
fields.mp.checkPostName = fields.mp.checkPostName || [
  { name: 'SOYAT', borderBarrier: 'AGAR MALWA' },

  { name: 'CHANDPUR', borderBarrier: 'ALIRAJPUR' },

  { name: 'RAMNAGAR TIRAHA', borderBarrier: 'ANUPPUR' },
  { name: 'VENKATNAGAR', borderBarrier: 'ANUPPUR' },

  { name: 'PRANPUR', borderBarrier: 'ASHOK NAGAR' },

  { name: 'BONKATTA', borderBarrier: 'BALAGHAT' },
  { name: 'RAKEGAON O', borderBarrier: 'BALAGHAT' },
  { name: 'SALETEKRI', borderBarrier: 'BALAGHAT' },

  { name: 'BALSAMUD', borderBarrier: 'BARWANI' },
  { name: 'NIWALI', borderBarrier: 'BARWANI' },

  { name: 'ANDANAKA', borderBarrier: 'BETUL' },
  { name: 'MULTAI', borderBarrier: 'BETUL' },

  { name: 'PHOOP', borderBarrier: 'BHIND' },

  { name: 'LONI', borderBarrier: 'BURHANPUR' },
  { name: 'SHAHPUR FATA', borderBarrier: 'BURHANPUR' },

  { name: 'KAIMAHA', borderBarrier: 'CHHATARPUR' },
  { name: 'LODI', borderBarrier: 'CHHATARPUR' },
  { name: 'PAHADIBANDHA', borderBarrier: 'CHHATARPUR' },
  { name: 'RANIGANJ TIGELA', borderBarrier: 'CHHATARPUR' },

  { name: 'RAJANA', borderBarrier: 'CHHINDWARA' },
  { name: 'SONSAR', borderBarrier: 'CHHINDWARA' },

  { name: 'CHIRULA', borderBarrier: 'DATIA' },

  { name: 'KABIR CHABUTARA', borderBarrier: 'DINDORI' },

  { name: 'UMARTHANA', borderBarrier: 'GUNA' },

  { name: 'BILUA', borderBarrier: 'GWALIOR' },

  { name: 'PITOL', borderBarrier: 'JHABUA' },
  { name: 'THANDLA', borderBarrier: 'JHABUA' },

  { name: 'MOTINALA', borderBarrier: 'MANDLA' },

  { name: 'JAMALPURA', borderBarrier: 'MANDSAUR' },
  { name: 'LEDICHOURAHA', borderBarrier: 'MANDSAUR' },

  { name: 'MORENA', borderBarrier: 'MORENA' },

  { name: 'BAGHANA', borderBarrier: 'NEEMUCH' },
  { name: 'NAYAGAON', borderBarrier: 'NEEMUCH' },

  { name: 'KHILCHIPUR C', borderBarrier: 'RAJGARH' },

  { name: 'PIPLODA', borderBarrier: 'RATLAM' },
  { name: 'SAILANA', borderBarrier: 'RATLAM' },

  { name: 'CHAKGHAT', borderBarrier: 'REWA' },
  { name: 'HANUMANA', borderBarrier: 'REWA' },

  { name: 'MALTHON', borderBarrier: 'SAGAR' },

  { name: 'MAJHGAWAN', borderBarrier: 'SATNA' },

  { name: 'KHAWASA', borderBarrier: 'SEONI' },

  { name: 'KARAHAL', borderBarrier: 'SHEOPUR' },
  { name: 'NAHAR', borderBarrier: 'SHEOPUR' },
  { name: 'SAMRASA', borderBarrier: 'SHEOPUR' },

  { name: 'KHARAI PADORA', borderBarrier: 'SHIVPURI' },
  { name: 'SIKANDARA', borderBarrier: 'SHIVPURI' },

  { name: 'MORWA', borderBarrier: 'SINGRAULI' },
];

// Ensure UI compatibility: alias with full name if some pages reference fields.madhyaPradesh
fields.madhyaPradesh = fields.madhyaPradesh || fields.mp;


// ---------------- Maharashtra ----------------
fields.maharashtra = fields.maharashtra || {};
fields.maharashtra.vehiclePermitType = fields.maharashtra.vehiclePermitType || [
  { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
  { name: "GOODS VEHICLE" }
];
fields.maharashtra.permitType = fields.maharashtra.permitType || [
  { name: "TOURIST" }
];
fields.maharashtra.borderBarrier = fields.maharashtra.borderBarrier || [
  { name: "MUMBAI" }
];
fields.maharashtra.checkPostName = fields.maharashtra.checkPostName || [
  { name: "MUMBAI CHECKPOST", district: "MUMBAI" }
];
fields.maharashtra.serviceType = fields.maharashtra.serviceType || [
  { name: "Tourist" }
];
fields.maharashtra.taxMode = fields.maharashtra.taxMode || fields.taxMode || [
  { name: "ANNUAL" },
  { name: "MONTHLY" }
];
// ---------------------------------------------------

// ---------------- West Bengal (wb) ----------------
fields.westBengal = fields.westBengal || {};

// basic
fields.westBengal.paymentMode = fields.westBengal.paymentMode || [
  { name: "CASH" },
  { name: "ONLINE" },
];

// vehicle permit types commonly used
fields.westBengal.vehiclePermitType = fields.westBengal.vehiclePermitType || [
  { name: "CONTRACT CARRIAGE/PASSANGER VEHICLES" },
  { name: "GOODS VEHICLE" },
  { name: "CONSTRUCTION EQUIPMENT VEHICLE" },
  { name: "PRIVATE VEHICLE" },
  { name: "EDUCATIONAL INSTITUTIONAL BUS" },
];

// permit types
fields.westBengal.permitType = fields.westBengal.permitType || [
  { name: "NOT APPLICABLE" },
  { name: "TEMPORARY PERMIT" },
  { name: "TOURIST PERMIT" },
  { name: "HOME STATE PERMIT" },
  { name: "NATIONAL PERMIT" },
];

// service types
fields.westBengal.serviceType = fields.westBengal.serviceType || [
  { name: "ORDINARY" },
  { name: "AIR CONDITIONED" },
  { name: "SLEEPER" },
  { name: "DELUXE" },
  { name: "NOT APPLICABLE" },
  { name: "LUXURY" },
];

// taxMode - reuse your common style
fields.westBengal.taxMode = fields.westBengal.taxMode || [
  { name: "DAYS" },
  { name: "WEEKLY" },
  { name: "MONTHLY" },
  { name: "QUARTERLY" },
  { name: "HALF YEARLY" },
  { name: "YEARLY" },
];

// Districts of West Bengal (official districts)
fields.westBengal.districtName = fields.westBengal.districtName || [
  { name: "ALIPURDUAR" },
  { name: "BANKURA" },
  { name: "BIRBHUM" },
  { name: "COOCH BEHAR" },
  { name: "DAKSHIN DINAJPUR" },
  { name: "DARJEELING" },
  { name: "HOOGHLY" },
  { name: "HOWRAH" },
  { name: "JALPAIGURI" },
  { name: "JHARGRAM" },
  { name: "KALIMPONG" },
  { name: "KOLKATA" },
  { name: "MALDA" },
  { name: "MURSHIDABAD" },
  { name: "NADIA" },
  { name: "NORTH 24 PARGANAS" },
  { name: "PASCHIM BARDHAMAN" },
  { name: "PASCHIM MEDINIPUR" },
  { name: "PURBA BARDHAMAN" },
  { name: "PURBA MEDINIPUR" },
  { name: "PURULIA" },
  { name: "SOUTH 24 PARGANAS" },
  { name: "UTTAR DINAJPUR" },
];

// check posts — each entry contains { name, district } so the UI can filter by district
// (add or adjust entries as you get authoritative local names)
fields.westBengal.checkPostName = fields.westBengal.checkPostName || [
  // NORTH 24 PARGANAS
  { name: "PETRAPOLE ICP", district: "NORTH 24 PARGANAS" },

  // MALDA
  { name: "PHULBARI CHECKPOST", district: "MALDA" },

  // JALPAIGURI
  { name: "HALDIBARI CHECKPOST", district: "JALPAIGURI" },

  // UTTAR DINAJPUR
  { name: "DALKHOLA CHECKPOST", district: "UTTAR DINAJPUR" },

  // COOCH BEHAR / ALIPURDUAR area (examples)
  { name: "ALIPURDUAR CHECKPOST", district: "ALIPURDUAR" },
  { name: "COOCH BEHAR CHECKPOST", district: "COOCH BEHAR" },

  // KOLKATA / HOWRAH metro area (examples)
  { name: "HOWRAH CHECKPOST", district: "HOWRAH" },
  { name: "KOLKATA (NORTH) CHECKPOST", district: "KOLKATA" },

  // PURBA MEDINIPUR / HALDIA area
  { name: "HALDIA CHECKPOST", district: "PURBA MEDINIPUR" },

  // PASCHIM MEDINIPUR
  { name: "KANAYANPUR CHECKPOST", district: "PASCHIM MEDINIPUR" },

  // HOOGHLY
  { name: "CHANDANNAGAR CHECKPOST", district: "HOOGHLY" },

  // generic fallback entries for districts without specific checkposts above
  { name: "DISTRICT CENTRAL CHECKPOST (ALTERNATE)", district: "PURBA BARDHAMAN" },
  { name: "DISTRICT CENTRAL CHECKPOST (ALTERNATE)", district: "PASCHIM BARDHAMAN" },
];

// also provide a lowercase alias in case some components use checkpostName (lowercase p)
fields.westBengal.checkpostName = fields.westBengal.checkpostName || fields.westBengal.checkPostName;

// permit categories (if used)
fields.westBengal.permitCategory = fields.westBengal.permitCategory || [
  { name: "REGULAR" },
  { name: "TEMPORARY" },
  { name: "SPECIAL" },
];

// goods name examples (if needed)
fields.westBengal.goodsName = fields.westBengal.goodsName || [
  { name: "GENERAL GOODS" },
  { name: "FOOD ITEMS" },
  { name: "AGRO PRODUCE" },
  { name: "FERTILIZERS" },
  { name: "CHEMICALS" },
  { name: "OTHERS" },
];

// alias so components using `fields.wb` continue to work
fields.wb = fields.westBengal;
